export default {
  common: {
    noFace: '無正反',
    noPermissionTip: '您暫無此功能的使用權限，請購買或續費後再進行操作。',
    selected: '選中',
    continue: '繼續',
    open1: '打開',
    doubleClick: '雙擊',
    inputKeywordSearch: '輸入關鍵詞搜索',
    inputKeywordStartSearch: '輸入關鍵字開始搜索',
    searchHistory: '搜索歷史',
    clearHistory: '清除歷史記錄',
    notFoundRelatedResults: '未找到相關結果',
    switch: '切換',
    searchProductionLine: '設備生產線',
    selectProductionLine: '選擇生產線',
    rotateAngleTip: '旋轉{angle}',
    plankText: '板件',
    sendToEzSort: '發送至彩標',
    downloadEzSort: '下載智繪彩標',
    notDownloadTip: '如果智繪彩標未能正常打開，可能是因為您沒有下載，請點擊下方按鈕下載智繪彩標',
    updateTip: '檢測到軟體更新，請重啟櫃櫃!',
    betaTest: '內測限免',
    ersortSpecail: '彩標專屬',
    exclusiveFeature: '專屬功能',
    elementCanBeDragTip: '元素可被拖動',
    checkPlankIsConflict: '正在檢測板件狀態',
    preferenceSaveErr: '偏好設定儲存異常',
    guimen: '櫃門',
    preferenceLoadTip: '正在加載您的偏好設置',
    preferenceLoadErrTip: '偏好設置加載失敗,請刷新重試,避免造成您的偏好設置錯誤！',
    localFileIsBeingWrite: '本地文件寫入中',
    unnamedFile: '未命名檔案',
    taskMonitor: '任務監控',
    downloadByType: '下載{type}',
    slotKnifeErr: '缺失槽指定加工刀具，請檢查生產線設置！【{msg}】',
    anewChooseCatalog: '重新選擇目錄',
    downloadSetting: '下載設置',
    attention: '注意',
    unit: '塊',
    defaultUse: '默認使用',
    defaultChooseUse: '默認選用',
    requestFail: '請求失敗',
    downloadDoneByType: '{type}下載完成',
    sysTip: '系統提示',
    pleaseChoose: '請選擇',
    confirmDelete: '確認刪除',
    notDataTipByType: '暫無數據，請先{msg}',
    paginationTotalTip: '第 {current}-{page} 條/總共 {total} 條',
    chooseAmountData: '已選 {number} 條數據',
    moreOperate: '更多',
    transferByType: '轉移{type}',
    clickCopy: '點擊可複製{type}',
    currentLine: '當前行',
    remark: '備註',
    customFunction: '定制功能',
    limitedTimeTrial: '限免',
    startDate: '開始日期',
    endDate: '結束日期',
    startTime: '開始時間',
    endTime: '結束時間',
    lastMonth: '最近一個月',
    lastSixMonth: '最近半年',
    lastYear: '最近一年',
    searchByType: '請輸入{type}查詢',
    addTime: '添加時間',
    startArrange: '開始排版',
    select: '選擇',
    search: '搜索',
    name: '名稱',
    plankNo: '板號',
    plankName: '板件名稱',
    orderNo: '訂單號',
    order: '訂單',
    partNameWithoutRoomCabinet: '板件名稱(不含房間櫃體)',
    plankRemark: '板件備註',
    room: '房間',
    orderAddress: '項目地址',
    matCode: '材質',
    matCode2: '材料',
    plankMatCode: '板材材質',
    count: '數量',
    customer: '客戶',
    customerInfo: '客戶資料',
    factoryOrderNo: '工廠單號',
    roomName: '房間',
    color: '顏色',
    plankColor: '板材顏色',
    plankThick: '板材厚度',
    plankHighGloss: '高光屬性',
    thick: '厚度',
    front: '正面',
    back: '反面',
    slot: '槽',
    hole: '孔',
    hsInfo: '{hole}孔{slot}槽',
    diameter: '直徑',
    finishedWidth: '成品寬度',
    finishedHeight: '成品長度',
    finishedArea: '成品面積(㎡)',
    remarks: '备注信息',
    remark1: '备注信息1',
    remark2: '备注信息2',
    remark3: '备注信息3',
    remark4: '备注信息4',
    remark5: '备注信息5',
    remark6: '备注信息6',
    remark7: '备注信息7',
    remark8: '备注信息8',
    remark9: '备注信息9',
    remark10: '备注信息10',
    remark11: '备注信息11',
    remark12: '备注信息12',
    remark13: '备注信息13',
    remark14: '备注信息14',
    remark15: '备注信息15',
    remark16: '备注信息16',
    texture: '紋理',
    normal: '豎紋',
    reverse: '橫紋',
    notCare: '無紋理',
    holeSlotsStastic: '孔槽數量',
    edge: {
      title: '封邊',
      info: '封邊信息',
      front: '前封邊',
      back: '後封邊',
      left: '左封邊',
      right: '右封邊',
      up: '上封邊',
      down: '下封邊'
      },
    isSpecial: '異形',
    notSpecial: '非異形',
    textOfDoorPlank: '的門板',
    textOfNotDoorPlank: '的非門板',
    isDoorPlank: '門板',
    notDoorPlank: '非門板',
    width: '寬度',
    long: '長度',
    plankWidth: '板材寬度',
    plankHeight: '板材長度',
    shortLong: '短邊長度',
    shortWidth: '短邊寬度',
    plankShape: '板材形狀',
    detail: '詳情',
    cancel: '取消',
    confirm: '確認',
    alreadyKnow: '我已瞭解',
    Noprompts: '不再提示',
    deep: '深度',
    other: '其他',
    heighGloss: '高光',
    heighGlossPlank: '高光板',
    heighGlossSide: '高光面',
    notHeighGloss: '非高光',
    notHeighGlossPlank: '非高光板',
    saveSuccess: '保存成功',
    deleteSuccess: '刪除成功',
    addSuccess: '添加成功',
    editSuccess: '修改成功',
    engraving: '雕刻機',
    electronicSaw: '電子鋸',
    glassEquip: '玻璃切割機',
    labelingMachine: '貼標機',
    copy: '複製',
    paste: '粘貼',
    undo: '撤銷',
    move: '移動',
    PTP: 'PTP',
    dock56FDrill: '五六面鑽',
    sideHoleDrill: '側孔機',
    combination: '組合設備',
    integration: '一體機',
    standardPlank: '標準大板',
    standardMaterial: '標準板材',
    standardMaterialTip: '注：完成大板信息調整後，在櫃櫃排版生產的用戶需要重啟櫃櫃客戶端，以應用最新的變更！',
    specialMaterial: '特殊板材',
    specialPlank: '特殊大板',
    singlePlank: '單面板',
    previous: '上一個',
    plankInfo: '大板詳情',
    moreResult: '更多排版方案',
    moreResultTip: '大板中有貼邊加工的槽,大板將不會參與重新排版',
    ok: '確定',
    dispersePaibanTip: '檢測到部分大板無法進行分散排版，您可以手動調整或切換排版方案，避免造成跑板！',
    next: '下一個',
    rate: '利用率',
    paibanBatch: '排版批次',
    return: '返回',
    FGNo: '合同號',
    refresh: '刷新',
    inde: '序號',
    productionLine: '生產線',
    operation: '操作',
    colorPlaceHolder: '按回車自動創建色卡',
    saveAndContinue: '保存並繼續',
    reset: '重置',
    check: '查詢',
    inputPlaceholder: '請輸入',
    filter: '篩選',
    all: '全部',
    exportPDF: '導出PDF',
    exportPic: '導出圖片',
    add: '添加',
    edit: '編輯',
    delete: '刪除',
    restore: '還原',
    save: '保存',
    saveSetting: '保存設置',
    isHeightGloss: '請選擇是否是高光板',
    noSync: '不同步',
    sync: '同步',
    formatSuccess: '{type}成功',
    dataLoading: '數據正在加載中......',
    warmTip: '溫馨提示',
    importantTip: '重要提示',
    wellcome: '歡迎使用雲排版',
    timeOut: '排版超時, 是否重新排版',
    notSawKnifeTip: '注意：鋸切雕刻機未設定橫切鋸片導致無法排版，請前往新增！',
    doorFrameKnifeRadiusErr: '您已開啟「鋸切雕刻機-門套切割」功能，下料刀半徑大於了鋸片厚度，無法進行排版！',
    doorFrameIrregularPlankErr: '您已開啟「鋸切雕刻機-門套切割」功能，該功能暫不支持異形板件排版！',
    warning: '警告',
    export: '導出',
    mark: '標記',
    noMark: '不標記',
    sawArrange: '鋸切排版',
    directArrange: '直切排版',
    area: '面積',
    plankNum: '板件條碼',
    loc: '櫃體',
    cutHeight: '下料長度',
    cutWidth: '下料寬度',
    defaultProduction: '默認生產線',
    surplusNum: '餘料條碼',
    tip: '提示',
    history: '歷史記錄',
    hinge: '鉸鏈孔',
    hingeScrew: '鉸鏈門板引孔',
    CCPXHole: '三合一偏心孔',
    stretchHinge: '拉直器槽與鉸鏈杯孔',
    stretch: '拉直器',
    stretcher: '拉直器槽',
    eccHole: '偏心孔',
    preHole: '預埋孔',
    clothole: '衣通孔',
    backPlank: '背板槽',
    ALS: '暗拉手槽',
    doorSlot: '門板金屬槽',
    drawerSlot: '抽屜金屬槽',
    lkSlot: '樂扣槽',
    KC: '褲抽孔',
    stealth: '隱形件',
    lightSlot: '燈槽',
    ConventionalHole: '常規孔',
    Keyhole: '鎖孔',
    allHole: '異形板上所有孔',
    allSlot: '異形板上所有槽',
    freedomAllHoleSlot: '自由異形板上所有孔槽',
    freedomAllHoleSlotTip: '自由異形板：是指異形板外四角沒有一個直角邊的異形',
    millInfo: '牛角拉手',
    haiTang: '海棠角',
    FSDrill: '五/六面鑽',
    engraving2: '開料機',
    xyReverse: 'XY軸互換',
    autoXYReverse: '孔槽加工設備自動適配互換',
    autoXYReverseTip: '啟用後五六面鑽的加工數據將自動適配雕刻機的XY軸互換',
    autoXYReverseTip2: '注：PTP暫不支持',
    xyReverseTip: 'XY軸互換功能暫未兼容L型餘料缺口正確擺放，請謹慎使用',
    rect: '矩形',
    Ltype: 'L形',
    archive: 'Archive',
    tellPlaceholder: '請輸入手機號',
    knivesStore: '刀庫',
    roll: '板件翻面',
    pause: '暫停',
    editTrans: '編輯翻譯',
    translateManager: '翻譯管理',
    grating: '格柵',
    addressEditErr: '多訂單暫不支持修改項目地址',
    customerEditErr: '多訂單暫不支持修改客戶資料',
    factoryEditErr: '多訂單暫不支持修改工廠單號',
    roomNameEditErr: '多訂單暫不支持修改房間名稱',
    remarkEditErr: '多訂單暫不支持修改訂單備註',
    toMaterialList: '前往開料清單',
    deleteFail: '刪除失敗，請稍後重試！',
    batchRestore: '批量還原',
    batchDelete: '批量刪除',
    workShop: '車間生產',
    FGAdrress: '項目地址/合同號',
    cuttingSize: '切割尺寸',
    finishedSize: '成品尺寸',
    labelImg: '貼標圖片',
    layoutImg: '排版圖',
    file: '文件',
    folder: '文件夾',
    reName: '重命名',
    to: '至',
    plankUnit: '張',
    tagTemp: '標簽模板',
    roomRemark: '房間備註',
    noModificationPermission: '沒有修改權限',
    modificationRecord: '修改記錄',
    page: '頁',
    strip: '條',
    jump: '跳',
    freeAgreement: '軟件免責協議',
    preStep: '上一步',
    nextStep: '下一步',
    upload: '上傳',
    uploading: '上傳中',
    iAgree: '我同意',
    pleaseSelectPlank: '請至少選擇一塊板件',
    saveToStoreTip: '請至少選擇一塊非裁剪板件',
    fileIsNotExist: '文件不存在',
    selectAll: '全選',
    pdfTag: 'PDF標簽',
    tagImage: '標簽圖片',
    guigui: '櫃櫃',
    gratingSlot: '格柵槽',
    deleteTip: '刪除該數據後不可恢復，是否確認刪除該數據？',
    deleteError: '出現未知錯誤，刪除失敗',
    cancelDelete: '已取消刪除',
    confirmDeleteTip: '刪除後板件將進入頁面右下角"板件待排版庫-未入庫"中，是否確認刪除該數據?',
    confirmDeleteBujianTip: '刪除後板件將進入頁面右下角"補件庫"中，是否確認刪除該數據?',
    confirmSureDeleteTip: '檢測到當前待排版庫中有相同材質的小板，刪除後待排版庫對應小板將不會展示，請確認是否繼續刪除該大板？',
    deleteEmptyTip: '是否刪除此大板',
    notCanDelete: '裁剪的餘料不支持入庫',
    new: '新增',
    innerBluneFailure: '內嵌雲排版不生效此功能',
    deleteBigPlankTip: '最後一張大板上存在小板，無法刪除！',
    continueExport: '忽略，繼續輸出文件',
    toCheck: '去檢查',
    pleaseCheck: '當前排版結果存在孔槽沖突/飛出小板/深度異常，請檢查！',
    clampHandCheck: '檢測到您部分板件的孔槽無法避讓夾手位置，請您手動調整',
    conflictPartDetail: '衝突的板件詳情',
    colorNotUndefined: '顏色不能為空',
    materialNotUndefined: '材質不能為空',
    newSetting: '新功能',
    downImageErrTip: '導出圖片失敗，因開啟貼標圖片根據大板分為不同文件夾，需勾選小板標簽一起導出',
    downNcErrTip: '下載NC失敗，因開啟貼標圖片根據大板分為不同文件夾，需勾選小板標簽一起導出',
    downNcErrTipForSurFolder: '下載NC失敗，貼標圖片根據大板分為不同文件夾和餘料大板文件設置不能同時開啟',
    yes: '是',
    no: '否',
    checkColorPrint: '當前已開啟彩色標簽，請使用彩色打印機進行打印哦~',
    colorRules: '開啟生成彩色標簽後，訂單/房間/櫃體/門板都會按照顏色進行區分，目前彩色標簽對同一類型的數據支持上限為12個，具體規則如下：',
    greyPart: '右邊標簽中灰色部分為',
    region: '區域',
    notSame: '不同{regionName}區域顏色不同',
    doorTip: '灰色為門板板件，白色為非門板板件',
    exist: '存在',
    limitNotEffect: '數據超過12個，彩色標簽不生效',
    hoverTip: '當前為bmp後綴的圖片，編碼格式黑白，無法輸出彩色標簽圖片',
    lock: '鎖定',
    unlock: '解鎖',
    batchLock: '批量鎖定/解鎖',
    surplusLock: '餘料鎖定',
    surplusUnlock: '餘料解鎖',
    is: '是',
    not: '否',
    savingHistory: '正在保存歷史文件',
    saveHistorySuccess: '保存歷史文件成功',
    saveHistoryFail: '保存歷史文件失敗',
    bw: '是否導出黑白標簽',
    modular: '單元櫃體',
    autoAdjust: '自動調整',
    cutOrderTip: '檢測到您的【第{errorCutOrdersString}張大板】切割順序存在錯誤！請進行調整後再下載NC文件',
    lockedCutOrderTip: '【第{errorCutOrdersString}張大板】已鎖定，請前往手動修改',
    paibanImgCutOrderTip1: '檢測到您的',
    paibanImgCutOrderTip: '切割順序存在錯誤！ 請前往排版頁調整後再匯出排版圖檔案',
    goAdjust: '去調整',
    autoAdjustWarning: '當前排版結果不支持自動調整',
    checkNetwork: '請檢查網絡',
    moreInfo: '查看更多信息',
    continueLayout: '繼續排版',
    adjustPosition: '調整設置',
    specialAndFiveSix: '五/六面鑽加工板件異形時，開啟異形嵌套可能會導致切到板件，請確認是否繼續排版？',
    plankPathErr: '板件內部異形數據錯誤,請檢查是否符合刀具規格!板號【{plankIDList}】',
    edgeCheck: '系統檢測到存在大板的修邊被修改，請重新排版確保生產準確',
    iKnow: '我知道了',
    versionErrTip: '請更新櫃櫃至最新版本!',
    annualFeeExpired: '您的年費已到期，請進行續費!',
    holeEquipment: '打孔設備{num}',
    customizedService: '支持定制化服務，打造您的專屬生產方案',
    exampleCombination1: '雕刻機+五/六面鑽+側孔機組合',
    exampleCombination2: '電子鋸+五/六面鑽+側孔機組合',
    exampleCombination3: '全自動一體生產線+五/六面鑽組合',
    feedback: '可以直接向您的櫃櫃軟件銷售或售後人員反饋您的需求',
    markModifiedBoards: '標識修改過的小板',
    showMoveStep: '自定義鍵盤移動步長',
    moveStep: '鍵盤移動步長',
    existChangeBoards: '存在變更的小板',
    crossMaterialBoard: '跨材質顏色小板',
    skipCrossMaterialTip: '本次排版不再提示',
    crossMaterialConfirmTip: '您目前正在跨不同材質或顏色挪動小板，{highlight}，是否繼續完成挪動？',
    crossMaterialConfirmTipHighlight: '挪動後生產出的小板可能和拆單的小板材質顏色不一致',
    exportHoleSlotPDF: '導出孔槽圖',
    pdfFormat: 'PDF格式',
    dxfFormat: 'DXF格式',
    specialShapeKnivesInfo: '異形選刀提示',
    specialShapeKnivesInfoTips: '第{stockNum}塊板件:',
    specialShapeKnivesInfoTips2: '開啟了異形自動選擇刀具，排版數據異常，請從開料清單重新排版，或者關閉異形自動選刀功能',
    default: '預設',
    exportLanguage: '匯出語言',
    exportLanguageTip: '注意：部分文字內容在導出PDF時無法翻譯',
    highGlossNameTip: '從櫃櫃同步的高光板可以被描述為其他文案，不影響其高光屬性',
    mixPaibanPlanSetting: '混排方案設置',
    mixPaibanPlanSettingTip: '系統檢測混排方案設置發生改變，請重新選擇本次混排方案！',
    mixPaibanPlanSettingOk: '設置混排方案',
    mixPaibanPlanSettingCancel: '不用,直接排版',
    noMixPaibanPlan: '暫無可用混排方案',
    mixColors: '混排顏色',
    mixPai: '混排',
    plan: '方案',
    mixPaibanTitle: '不同顏色小板排一起',
    mixColorsTip: '可以定義哪些顏色的板件能夠作為同一種顏色排在同一張大板上進行生產，同時不改變板件的原本顏色信息。',
    mixColorsTip2: '添加方案后需要在開料清單中開啟才會生效',
    mixColorsTip3: '異色封邊功能存在衝突暫時無法同時生效該功能',
    mixErrTip: '混排方案缺失必填項，請檢查',
    addPlan: '添加方案',
    chooseMatcode: '選擇材質',
    chooseColor: '選擇顏色',
    defineColor: '將選中顏色定義為',
    confirmDeletePlan: '確定要刪除該方案嗎',
    trimmingMethod: '修邊方式',
    followStandardTrim: '跟隨原片中標準板材的修邊值',
    trimToast: '注意：您使用了餘料自定義修邊功能，僅可選擇鋸切排版',
    individualTrimValue: '單獨設定修邊值',
    topTrimEmptyToast: '上修邊不能為空',
    bottomTrimEmptyToast: '下修邊不能為空',
    leftTrimEmptyToast: '左修邊不能為空',
    rightTrimEmptyToast: '右修邊不能為空',
    topTrimBlurToast: '請輸入上修邊值',
    bottomTrimBlurToast: '請輸入下修邊值',
    leftTrimBlurToast: '請輸入左修邊值',
    rightTrimBlurToast: '請輸入右修邊值',
    effectToast: '自定義修邊功能僅對 焊接板 生效',
    defaultTrimSetting: '餘料預設修邊設定',
    enterHere: '這裡輸入',
    permissionTipExportDxf: '導出樣式二孔槽圖DXF',
    permissionTipSurplusRecycleBin: '餘料回收站',
    permissionTipAdvancedNesting: '高級異形嵌套',
    permissionTipPanelGrainAlign: '板件對紋',
    permissionSeparator: '、',
    missingPermissionTip: '缺少以下權限：{permissions}'
    },
  home: {
    head: {
      production: '產品介紹',
      resolve: '解決方案',
      about: '關於我們',
      equipment: '機器設備',
      tell: '投訴電話',
      enter: '進入雲排版'
      },
    swiper: {
      case1: {
        tag: '全新升級版',
        subTitle: '機器的智能大腦',
        description: '改革行業的雲端在線排版優化軟件'
        },
      case2: {
        title: '櫃體生產',
        subTitle: '技術革新',
        description: '支持多種貼標機、開料機、側孔機、五面PTP、五/六面鑽對接'
        },
      case3: {
        title: '工業大腦',
        subTitle: '解決方案',
        description: '智能排版算法獲得板材更高利用率'
        }
      },
    statistics: {
      today: '今日排班量',
      toMounth: '當月排版量',
      outturn: '出材率',
      cumulative: '累計用戶'
      },
    intro: {
      title: '企業級大數據 雲端在線排版軟件',
      subTitle: ' 洞察行業態勢，聚焦客戶需求，賦能企業數字化轉型升級，推動互聯網家具生產自動化產業變革 針對現有板式家具行業生產場景，推出AI輔助算法，持續為企業實現貢獻新增長 ',
      menue: {
        case1: {
          title: '在線排版',
          subTitle: '任何時刻均可排版',
          description: '無需下載軟件，任何時刻均可排版,遠程操控不必依賴於電腦'
          },
        case2: {
          title: '多線生產',
          subTitle: '生產線快速切換',
          description: '支持多條生產線同時快速加工，生產線之間可以進行快速切換'
          },
        case3: {
          title: '精細生產',
          subTitle: '精細排版，精細參數設置',
          description: '精細排版，精細參數設置，讓板件生產變得更加精確化'
          },
        case4: {
          title: '自定義生產',
          subTitle: '自定義標簽、五六面鑽、餘料形狀',
          description: '自定義標簽，自定義五六面鑽，自定義餘料形狀，組合設備加工'
          }
        }
      },
    fangan: {
      title: '行業專業解決方案',
      subTitle: ' 低成本，高產值，智能算法提高板件利用率，兼容多種設計軟件，為用戶提供最優生產方案 ',
      menue: {
        case1: {
          title: '線上接單生產一體化',
          description: ' 遠程線上操作，跨越空間阻礙，隨時輸出訂單同步工廠，設計生產同步完成 '
          },
        case2: {
          title: '一鍵切換生產線',
          description: '自定義生產線，支持多生產線，多類型設備對接'
          },
        case3: {
          title: '智能算法提高板材利用率',
          description: '傳統算法板材利用率低，智能算法精細參數設置，定制生產方案'
          },
        case4: {
          title: '專業切割方案',
          description: '優化切割順序、下刀點，讓路徑更短切割更穩'
          }
        }
      },
    aboutUs: {
      title1: '新格爾人居科技',
      subTitle: '家具生產業變革創領者',
      description: '新格爾企業，專注實現傳統家具生產業的互聯網變革',
      culture: {
        case1: {
          title: '企業宗旨',
          subTitle: '幫助工廠，三倍增長'
          },
        case2: {
          title: '文化價值觀',
          subTitle: '以客戶為中心，以奮鬥者為本，艱苦奮鬥，造福人民'
          },
        case3: {
          title: '指導思想',
          subTitle: '群眾路線，搭建具有銷售力、產品力、組織力的精英團隊'
          }
        },
      feature: {
        case1: '專業團隊維護',
        case2: '持續更新迭代',
        case3: '一對一售後服務',
        case4: '功能定制服務'
        }
      },
    cooperation: {
      title: '精誠合作 共創未來',
      subTitle: ' 對接設備品牌覆蓋90%國內工廠常用設備，107554位商家與我們同行 '
      },
    footer: {
      contact: {
        title: '聯繫我們',
        adrres: '地址：江蘇省無錫市濱湖區繡溪50號',
        subAdrres: 'K-park服務中心1號樓16樓',
        tell: '電話'
        },
      business: {
        title: '新格爾核心業務',
        department1: '門窗軟件事業部',
        department2: '家具軟件事業部',
        department3: '裝配建築事業部',
        department4: '新格爾總部官網'
        },
      brand: {
        title: '新格爾旗下品牌',
        brand1: '材神金服',
        brand2: '門圖網',
        brand3: '鼎鑫投資',
        brand4: '三張圖科技',
        brand5: '上海粉墨科技'
        },
      organization: {
        title: '新格爾全球分支機構',
        organization1: '新格爾-華南局（佛山分公司）',
        organization2: '新格爾-北方局（臨沂分公司）',
        organization3: '新格爾-西南局（成都分公司）',
        organization4: '新格爾-櫃櫃西部服務中心',
        organization5: '新格爾-櫃櫃東部服務中心',
        organization6: '新格爾-代理商集群',
        organization7: '新格爾-國際市場部'
        },
      follow: {
        title: '掃掃"關注櫃櫃"'
        },
      friendLink: {
        link1: '新格爾軟件',
        link2: 'K秀導購軟件',
        link3: '門圖網',
        link4: '全鋁櫃軟件',
        link5: 'ZOL軟件下載',
        link6: '華軍軟件園',
        link7: '下載之家',
        link8: 'ZOL軟件下載',
        link9: '綠色資源網',
        link10: '衣櫃加盟',
        link11: '家居加盟',
        link12: '美標衛浴加盟'
        }
      }
    },
  login: {
    title: '登錄',
    tell: '手機號',
    password: '密碼',
    passwordPlaceholder: '請輸入密碼',
    forget: '忘記密碼',
    registerAccount: '註冊帳號',
    backLog: '返回登錄',
    verifyCode: '驗證碼',
    getVerifyCode: '獲取驗證碼',
    verifyCodeErr: '驗證碼錯誤',
    confimPassword: '確認密碼',
    confimPasswordPlaceholder: '請確認密碼',
    editPassword: '修改密碼',
    register: '註冊',
    reSend: '後重新獲取',
    loginLoadText: '正在登錄中,請稍等...',
    loadingPageTextL: '登錄成功,正在加載頁面結構中...',
    loginSuccess: '登錄成功',
    tellErr: '手機號碼格式不正確',
    passwordErr: '請輸入密碼'
    },
  main: {
    head: {
      title: '雲排版',
      subTitle: '省時，省料，省力氣',
      task: '接任務',
      arrange: '排版',
      surplus: '餘料',
      setting: '設置',
      find: '發現',
      upgrade: '立即升級',
      editNickName: '修改暱稱',
      editPassword: '修改密碼',
      logout: '退出登錄',
      notice: '公告',
      enterOfficial: '前往官網',
      equipment: '機器設備',
      help: '幫助',
      importFunc: '查看專屬功能',
      enterThinkerOfficial: '進入新格爾官網',
      history: '保存歷史',
      plankManager: '原片管理',
      tagManager: '標籤管理',
      suplumentManager: '補件和待排版庫',
      fileManager: '文件管理',
      productionLine: '設備對接',
      workeShop: '雲端生產',
      useLesson: '使用教程',
      videoLesson: '視頻教程',
      prolineManager: '生產線管理',
      materialManager: '板件管理',
      productManual: '產品手冊',
      medialRelated: '梯度相關'
      },
    sideBar: {
      title: '生產優化',
      materialList: '開料清單',
      paibanTask: '排版任務',
      paibanResult: '排版方案',
      printTag: '打印標籤',
      history: '保存歷史',
      limitDate: '限免',
      surplusManager: '餘料管理',
      translateManager: '翻譯管理',
      moreSettings: '更多設置',
      deepSeekTitle: '諮詢顧問',
      paibanCommune: '排版交流群組'
      },
    allRead: '全部已讀',
    learnMore: '了解詳情',
    noticeEmpty: '暫無公告....',
    noticeErr: '獲取詳細公告內容錯誤',
    feedBack: {
      tab1: '提交反饋',
      tab2: '反饋記錄',
      type: '意見類型',
      typePlaceholder: '請選擇功能',
      description: '描述',
      descriptionPlaceholder: 'hi～請填寫不少於15字的詳細使用場景描述，以便我們更好地為您提供幫助，感謝配合！',
      uploadPic: '添加圖片，最多可添加6張，單張圖片大小不超過10M）',
      tell: '聯繫電話',
      submit: '提交',
      admin: '雲排版管理員：',
      picTip: '圖片:(單擊展開查看圖片詳情)',
      empty: '暫無反饋數據',
      picErr: '單張圖片大小不超過10M',
      contentErr: '字數應在 15 到 300 之間',
      necessary: '該選項必填'
      }
    },
  taskPage: {
    tab1: '生產任務',
    tab2: '批量生產隊列',
    filter: {
      title: '篩選',
      unArrange: '未排版',
      arranged: '已排版',
      allArranged: '全部已排版',
      preLayout: '預排版'
      },
    search: {
      placeholder: '請輸入搜索內容',
      orderName: '訂單名稱',
      sender: '發送人'
      },
    importTask: '導入任務',
    refuseTask: '拒絕任務',
    refreshList: '刷新列表',
    refuseRecord: '拒絕記錄',
    taskCard: {
      sender: '導入的料單',
      delivery: '交期',
      delete: '刪除',
      addToBatch: '加入批量',
      save: '存檔',
      arrange: '直接排版',
      deleteTitle: '刪除任務',
      checkDetail: '點擊查看詳情',
      refuse: '拒絕',
      refuseTime: '拒絕時間',
      refuseReason: '拒絕原因',
      refuseTask: '拒收任務',
      refuseTaskPlaceholder: '請輸入拒收原因',
      addErr: '添加失敗,請稍後重試!'
      },
    batchNo: '批次號',
    batchArrange: '批量排版',
    clearBatch: '清空隊列',
    taskCount: '當前任務數量:',
    checkAllTask: '查看所有料單',
    clearSuccess: '清除成功',
    record: {
      batchNo: '批次',
      saveDate: '保存時間',
      materialList: '料單',
      arrangedRecord: '排版方案',
      searchPlaceholder: '請輸入批次號',
      tipText: '是否刪除該條存檔?'
      },
    errTip: '無可加工的任務數據,請前往任務列表添加!',
    emptyErr: '該任務訂單沒有板件數據，無法進行排版生產！',
    operationSuccess: '操作成功',
    operationFail: '操作失敗,請稍後重試!',
    saveSuccess: '存檔成功',
    plankMaxLimit: '小板數量超過最大排版上限',
    batchWorning: '請分批次進行生產',
    batchEmptyErr: '訂單列表沒有板件數據，無法進行批量生產！',
    noRoomTip: '不存在房間，無法進行批量生產！',
    refuseHistory: '拒絕歷史'
    },
  materialPage: {
    specialProcess: '特殊工藝',
    distanceFromTop: '距上',
    distanceFromRight: '距右',
    hingeData: '鉸鏈數據',
    labelBackProcTip: '本次更新已對大板反面貼標方式進行優化，現在按照標籤上的信息直接封邊，打孔拉槽即可，望您知曉!',
    openDir: '開門方向',
    edgeEmptyTip: '修邊值不能為空',
    edgeNumberLimit: '修邊值只能輸入數字',
    chooseSurplusQuantity: '可用餘料共 {total} 種，已選 {quantity} 種',
    noCanSaveInfo: '沒有可以保存的信息',
    chooseBujianStoreQuantity: '共 {total} 塊補件，可順帶補件板件共 {quantity} 塊，已選 {chooseQuantity} 塊',
    isConfirmPushToAwaitStore: '是否確認將所選板件添加到待排版庫?',
    enterAutoCreateMatCode: '按回車將自動創建材質',
    chooseAwaitStoreQuantity: '共 {total} 塊待排版庫小板，可順帶排版的板件共 {quantity} 塊，已選 {chooseQuantity} 塊',
    defaultFold: '板件數據默認收起',
    startArrange: '開始排版',
    importMaterial: '導入開料清單',
    saveToHistory: '保存至歷史',
    addPlank: '添加板件',
    addBujian: '添加補件',
    deletePlank: '刪除板件',
    batchEdit: '批量修改',
    moreSetting: '更多設置',
    plankSize: '板件尺寸',
    plankSize2: '尺寸(長*寬*厚)',
    searchPlaceholder: '搜索板件名稱/板號',
    checkArranged: '查看排版',
    checkErr: '未進行排版, 無法查看!',
    downloadSheet: '下載樣表',
    downloadSheetShowScientific: '下載樣表（展示科學計數法）',
    exportHoleSlotPDF: '導出板件孔槽圖',
    style1: '樣式一',
    style2: '樣式二',
    style2PDF: '樣式二(PDF)',
    style2DXF: '樣式二(DXF)',
    style3: '樣式三',
    importNoCover: '料單導入不覆蓋',
    openBujianPlankRecommend: '開啟補件小板推薦',
    openAwaitStorePlankRecommend: '開啟待排版庫小板推薦',
    openSurplusPlankRecommend: '開啟餘料大板推薦',
    pushToAwaitStore: '存入待排版庫',
    setTableHead: '設置開料清單表頭',
    syncConfirm: '櫃櫃與雲排版原片數據不一致！是否同步為櫃櫃原片數據？',
    handleSync: '注：可在原片管理中進行手動同步',
    noMoreTip: '不再提示',
    checkMore: '查看更多',
    noHistory: '暫無保存歷史…',
    sameOrder: '存在已導出生產文件的訂單，請注意重複生產問題！',
    markOrder: '是否在訂單頁面標記已生產？',
    editErrTip: '多訂單暫不支持修改信息',
    autoSaveSuccess: '已自動保存至歷史!',
    goAdd: '前往添加',
    noProductionLine: '該條記錄的生產線已被刪除，請前往開料清單重新排版',
    fileErr: '解析文件內容失敗，請確認文件內容!',
    noCheckData: '沒有查詢到數據!',
    noArrangeTip: '無法直接查看排版方案,請點擊開始排版！',
    tooOld: '五六面鑽設置過老',
    contactUs: '請聯繫售後人員重新對接',
    pathErr: '板件內部存在異常數據（板號：{errorPathPlankID}），請檢查！',
    sizeErr: '存在過大板件！小板尺寸：{width}-{height}',
    noKnife: '未設置下料刀直徑, 請前往雕刻機設置刀具!',
    noKnifeDiameter: '該生產線下料刀（{name}）直徑為空，請前往添加對應刀徑',
    openDifferentMaterialCuttingKnives: '已開啟不同材質下料刀',
    sendFactorySuccess: '發送至車間成功',
    sendFactoryErr: '發送車間失敗，請聯繫售後人員請求幫助',
    createTaskCard: '是否創建對應的任務卡片?',
    surplusStatistics: '可用餘料共',
    surplusStatistics2: '已選',
    suplementStatistic: '塊補件，可順帶補件板件共',
    expand: '展開',
    packUp: '收起',
    importErr: '請選擇正確的文件!',
    sendLoadingText: '正在處理並發送NC文件......',
    arrangeLoading: '共計',
    arrangeLoading2: '張小板正在優化排版中......',
    dealing: '正在處理中...',
    deleteConfirm: '刪除後，餘料將被移入餘料回收站。是否確認刪除此餘料？',
    copyTip: '即將對選中餘料進行複製操作',
    copyTip2: '請確認需要複製的數量',
    surplusHead: {
      shape: '形狀',
      type: '類型',
      remark: '備註',
      area: '面積(m²)',
      area1: '面積'
      },
    surplusTip: '暫無可用餘料，您可以先去',
    creatSurplus: '新建餘料',
    orderInfo: '訂單信息',
    suplement: {
      statistic: '共{total}塊補件，可順帶補件板件共{useable}塊，已選{selected}塊',
      exportSuplement: '導出補件清單',
      suplementLoading: '補件數據加載中',
      exportSuplementIng: '補件清單正在導出',
      noMatchSup: '未能匹配到可使用的補件數據',
      exportTip: '請至少選中一塊補件再進行導出'
      },
    empty: '暫無板件數據',
    paibanSetting: {
      title: '排版設置',
      createTask: '創建排版任務',
      selectProduction: '生產線選擇',
      arrangeWay: '排版方案選擇',
      suitText: '適用於：',
      surplusTrimTip: '注意：您使用了餘料自定義修邊功能，僅可選擇鋸切排版',
      suitEquipmentNormal: '常規雕刻機',
      suitEquipmentSpecial: '玻璃切割機、鋸片切割機',
      lessRoll: '少翻板',
      computedSpecial: '計算異形',
      specialTip: '影響排版速度',
      irregularNesting: '異形嵌套',
      primaryNesting: '普通嵌套',
      specialShapedPanel: '異形嵌普通板',
      limitedTimeTrial: '限免',
      seniorShape: '高級嵌套',
      heteromorphicInlay: '異形嵌異形',
      autoCutSurplus: '餘料自動裁剪',
      cutWay: '裁剪方式',
      maxRect: '裁剪為最大矩形',
      fixedRect: '裁剪為固定尺寸',
      minRectSetting: '裁剪最小尺寸',
      firstCutL: '裁剪優先生成L形餘料',
      firstCutLTip: '開啟後會優先將滿足條件的矩形板組合裁剪為L形餘料',
      shortLine: '短邊大於',
      longLine: '長邊大於',
      setDifferentThickness: '設置不同厚度板件最小裁剪尺寸',
      defaultRuleTip: '當板件厚度沒有命中規則時，按照默認規則裁剪',
      panelThickness: '大板厚度',
      duplicateMinCutSize: '當前厚度已存在相同的最小裁剪尺寸',
      templateEmpty: '「設置不同厂度板件最小裁剪尺寸」模板數據不能為空！',
      duplicateThicknessData: '「設置不同厂度板件最小裁剪尺寸」模板數據中存在重複的厂度數據！',
      atLeastOne: '至少保留一項!',
      maxAddFive: '最多添加五個!',
      surplusTemplate: '餘料常用模版',
      add: '添加',
      templateErr: '選擇裁剪為常用尺寸，需要選擇至少一個數據模板',
      cutLong: '裁剪長度',
      cutWidth: '裁剪寬度',
      baseInfo: '基本信息',
      continue: '確認並繼續',
      standardSelect: '標準大板選擇',
      customPlankOrder: '自定義大板排版順序',
      customPlankOrderDetail: '未排小板清單',
      customPlankOrderTip: '內嵌雲排版不生效此功能',
      customPlankOrderBrandTip: '待排版訂單存在品牌色卡板件，默認使用此功能',
      surplusPlank: '剩餘小板清單',
      overSizePlank: '超尺板件清單',
      plankOrder: '排版順序',
      plankType: '板材類型',
      plankSize: '板材尺寸',
      plankEdgeOff: '修邊值',
      amount: '下料數量',
      amountMax: '下料數量最大',
      numAndOverSizeTip: '存在小板超尺且大板用量不足無法排版',
      numErrorTip: '大板用量不足無法排版',
      overSizeTip: '存在小板超尺無法排版',
      restPartList: '未排小板清單',
      layoutOrder: '排版順序',
      arrangeAmount: '下料數量',
      specialShapeTip: '異形餘料不能使用鋸切排版',
      surplusConflictTip: '裁剪餘料與板件輪廓衝突，請重新裁剪',
      stackingMethod: {
        title: '排版堆疊方式',
        long: '靠長邊排版',
        short: '靠短邊排版'
        },
      seniorShapeTip: '【高級嵌套】限免體驗已到期，當前可預覽高級嵌套排版結果（也可切換普通嵌套進行正常排產），如需導出高級嵌套排產文件，請聯繫銷售人員購買~'
      },
    filter: {
      title: '板件篩選',
      search: '搜索',
      all: '全選',
      diskSize: '排版歷史數據空間已使用',
      resetFilter: '取消篩選'
      },
    edit: {
      title: '批量修改',
      target: '修改對象',
      onlineSelectRow: '僅選中行',
      allRow: '全部行',
      editKey: '需修改內容',
      editValue: '修改為',
      warningTip: '注意 ：修改後將自動清除孔槽和異形',
      allEdge: '全部封邊'
      },
    add: {
      title: '添加板件',
      continue: '確認並繼續',
      matCodeErr: '材質不能為空',
      thickErr: '厚度不能為空',
      colorErr: '顏色不能為空',
      longErr: '成品長度不能為空',
      widthErr: '成品寬度不能為空',
      countErr: '數量至少為1'
      },
    delete: {
      tip: '刪除該數據後不可恢復，是否確認刪除該數據？',
      errTip: '請先至少選中一個板件再進行此操作!',
      errTip1: '請至少選中一個板件再進行排版',
      confirm: '確認刪除'
      },
    restore: {
      confirm: '確認還原'
      },
    restoreConfirm: '還原後，餘料將移回餘料清單或餘料庫。是否確認還原此餘料？',
    restoreBatchConfirm: '確認要還原選中的餘料嗎？',
    save: {
      errTip: '沒有可以保存的信息!',
      title: '保存方案',
      subTitle: '(注：歷史僅保存一年)',
      name: '方案名稱',
      historyName: '歷史方案',
      successTip: '保存成功!',
      fieldTip: '保存失敗!'
      },
    exportErr: '暫無板件,無法進行導出',
    exportPicErr: '導出板件孔槽圖時遇到未知錯誤，請聯繫我們解決',
    plankNotFound: '未查詢到相關板件!請確認是否繪製板件!',
    noPlankName: '未找到板件名稱',
    plankDataErr: '板件數據錯誤，請仔細檢查，避免生產損失',
    exportThreeViewErr: '導出孔槽三視圖失敗,請聯繫售後處理',
    heighGlossWarning: '注意：材質為高光板時，修改材質後板件將無法恢復成高光板！',
    reset: '恢復默認',
    settingHead: {
      title: '設置開料清單表頭',
      head: '表頭',
      customHeadName: '自定義表頭名',
      example: '樣例',
      tip: ' 操作提示：可左右拖動 表頭數據標籤 位置 ',
      headerNameEmpty: '表頭不能為空',
      duplicateHeader: '存在重複表頭'
      },
    copyLine: '點擊可在下方複製當前行',
    copySuccess: '複製{name}數據成功',
    arranging: '共計{count}張小板正在優化排版中......',
    overSize: {
      title: '板件超尺',
      subTitle: '超尺板件清單',
      overSizeTip: '板件超尺提示',
      nonWorkInfo: '無法加工的板件詳情',
      mergeFrameDoorWholeTip: '注意：本部件為組合加工的骨骼門整體',
      conflictWorkInfo: '衝突的板件詳情',
      warning: '檢測到有小板尺寸過長，導致無法排版！請調整小板尺寸或添加對應尺寸原片',
      checkInfo: '查看板件詳情',
      tipContent: '系統檢查到排版小板中存在超尺板件，下面是特殊板材添加建議，可以手動修改板材長寬後點擊表格下方<span class="bold color-0">"一鍵添加"</span>按鈕，快速添加後繼續排版，也可以在<span class="bold color-0">原片設置-特殊板材</span>手動添加板件 ',
      add: '一鍵添加',
      addPlank: '添加原片',
      error: '板件超尺，排版失敗',
      successTip: '板件添加成功！正在重新排版',
      warningTip: '請填寫板件的長寬！'
      },
    arrangeErr: '板件內部數據存在異常，無法進行排版生產',
    nonDelete: '不可刪除',
    addOverSizeTip: '存在超尺，請重新添加',
    addPlankSuccess: '添加特殊大板成功',
    addPlankFail: '添加特殊大板失敗',
    paibanFeedback: '排版回饋',
    cuttingAndPaoban: '切割跑板',
    lowUtilizationRate: '利用率低',
    unreasonableLayout: '排版不合理',
    feedbackSuccessTip: '回饋成功！',
    feedbackFailTip: '回饋失敗！',
    mixedLayoutScheme: '本次混排方案'
    },
  arrangedPage: {
    subtleDownloadCheckTip: '板件數據已發生變化，但未保存方案，請點擊確定保存方案，再進行後續操作',
    paibanRequestFailed: '排版請求失敗，請重試',
    accordingPlankCountOrder: '按照大板數量由高到低排序',
    editOrder: '編輯序號',
    dragOrder: '拖動排序',
    inputOrder: '輸入順序',
    editOrderTip: '順序調整',
    range: '範圍',
    unsupportRotateTip: '部分大板已旋轉，暫不支持重新排版，已旋轉大板序號：',
    slotErrTip: '當前板件存有貼邊加工的槽，不支持重新排版！',
    lockedPaibanTip: '大板被鎖定，無法重新排版',
    batchBujianErrTip: '當前板件不存在料單原始數據中，可在補件/待排版庫中選擇重新排版',
    useFolderIsNot: '檢測到您的文件下載保存位置"{type}"不存在 ! 請檢查該文件夾是否被刪除，如果使用的是移動U盤請檢查U盤連接是否正確',
    useFolderIsNot1: '檢測到您並未設置文件下載位置，請先選擇目錄',
    downloadNC: '下載NC',
    downloadNC1: '下載NC文件',
    reArrange: '重新排版',
    reArrangeSpecifiedMaterialGroup: '指定板件組重新排版',
    specifiedMaterialRelayoutMoreResultTip: '指定板件組重新排版後，將不再提供更多排版結果',
    searchMaterialGroup: '搜索板件組',
    saveToHistory: '保存至歷史',
    moreSetting: '更多',
    cutIndexRe: '使用快捷鍵 ctrl+z 撤銷上一步操作',
    followExportTag: '下載NC順帶導出標籤文件',
    followExportPaibanImg: '下載NC順帶匯出排版圖檔案',
    followExportWorkerShop: '下載NC順帶匯出採購單',
    tagTemplateSelect: '標籤模板選擇',
    showCuttingSequence: '顯示切割順序',
    showPlankSize: '顯示小板尺寸',
    sendToFactory: {
      title: '發至車間',
      fileType: '標籤文件類型'
      },
    checkData: '正在檢查數據完整性...',
    dataLoading: '正在努力加載中......',
    addToBujianStore: '正在添加進補件倉庫...',
    updateTaskStatus: '正在更新任務狀態...',
    sending: '正在發送至車間',
    waitLoadding: '等待',
    loadding: '正在',
    finish: '完成',
    loadSetting: '加載設置',
    loadPreference: '加載偏好設置',
    dealTemplate: '處理模板',
    initTagData: '初始化標籤數據',
    prepareDrawData: '準備標籤繪製數據',
    drawDataText: '標籤繪製數據',
    genPdfTagFile: '生成PDF標籤文件',
    genPicTagFile: '生成標籤圖片文件',
    uploadFile: '上傳文件',
    dealNCFile: '處理NC文件',
    zipFile: '生成本地壓縮文件',
    plankCount: '大板數量',
    rollCount: '翻板次數',
    totalRate: '整體優化率',
    rate: '優化率',
    useArea: '已優化面積',
    materialList: '料單',
    saveSurplus: '餘料入庫',
    workeShop: '採購單',
    batchTagging: '批量補標籤',
    batchTaggingTip: '請在下方選擇需要補打標籤的板件',
    holeSlotErr: '檢測到板件存在孔槽深度異常!',
    knivesErr: '檢測到板件找不到加工刀具!',
    checkDetail: '查看詳情',
    deepErr: {
      title: '板件孔槽深度異常',
      errStatistic: '次小板有{count}處異常',
      errText: '異常部分',
      markErrPart: '框出異常部分'
      },
    warningTip: ' 雙面加工的高光板：先加工 <span class="font-style">高光面</span> , 再加工 <span class="font-style">啞光面</span>; 單面加工的高光板：直接加工 <span class="font-style">啞光面</span>',
    showDetail: {
      tip1: '單擊選擇單個板件',
      tip2: '查看板件標籤'
      },
    arrangeTip: '(已支持異形嵌套排版)',
    plankOpration: '板件操作',
    rotate: '旋轉90度',
    notCare: '板件無紋理',
    editRemark: '編輯備註',
    clearRemark: '清空備註',
    recalcIndex: '重新計算下刀點和切割順序',
    recalcIndexSuccess: '重新計算下刀點和切割順序成功',
    storageArea: {
      title: '板件暫存區',
      empty: '無板件暫存',
      storageTip: '可將板件拖至此處進行板件暫存'
      },
    subtleArrange: '精細排版',
    addPlank: '添加大板',
    deletePlank: '刪除大板',
    deletePlankErr: '當前大板存在小板, 不可刪除大板!',
    useSurplus: {
      title: '使用餘料'
      },
    dragWarning: '請將板件拖動至大板上!',
    areaWarning: '無法放置板件,留意空餘空間大小',
    subtlePage: {
      cut: '餘料裁剪',
      lineTip: '如果手動裁剪有誤可以ctrl+z返回上一裁剪點位',
      cancelCut: '結束裁剪',
      cutPoint: '餘料裁剪吸附點',
      storageArea: '板件待排板區',
      cutErr: '只能在大板上進行切割, 不能觸碰小板!',
      saveErr: '請先選擇一個裁剪的餘料',
      cutErr2: '只能在大板上進行切割, 不可超出大板!',
      selectTip: '請選擇一個裁剪的餘料板件',
      noCutPath: '異形部分不能裁剪矩形',
      cutOperate: '餘料裁剪操作',
      line: '手動描邊',
      cutErrtip: '裁剪點位存在交叉問題，請重新裁剪',
      cutErrtip2: '裁剪點位將超出點位限制:9，請重新裁剪'
      },
    shortCut: '快捷鍵',
    updownRoll: '上下滑動',
    leftRightRoll: '左右滑動',
    zoomScale: '放大縮小',
    dragCanvas: '拖動頁面',
    mouseRoll: '鼠標滾輪',
    mouseRight: '鼠標右鍵',
    mouseMultiSelect: '多選板件',
    mouseLeft: '鼠標左鍵',
    doublePlank: '雙擊大板',
    keyboard: '鍵盤',
    picSymble: '圖例',
    funished: '成品',
    holeSlotConflict1: '孔槽衝突',
    plankErr: '板件衝突',
    frontSlot: '正面拉槽',
    backSlot: '反面拉槽',
    frontHole: '正面孔位',
    backHole: '反面孔位',
    resetScale: '重置縮放',
    maxLong: '最長',
    tempErr: '添加失敗,模板位置不正確或模板過大!',
    sendErr: '發送車間失敗，請檢查標籤模板與板件數據是否正確之後重新發送',
    someTips: '您正在限時試用雲排版異形餘料/異形嵌套功能，請注意規避生產問題！',
    nestingTips: '【高級異形嵌套排版】功能-限免體驗已到期，如需繼續使用，請聯繫銷售人員購買！',
    frameDoorTip: '檢測到本次排版有合并的骨骼門，注意骨骼門二次加工前需要先封邊再上雕刻機切割！',
    cutOrderErr: '切割順序不正確，請點擊重新計算下刀點和切割順序！',
    holeSlotConflict: '檢測到板件存在孔槽衝突/飛出小板',
    exportSetting: '導出設置',
    currentTagTemp: '當前標籤範本',
    specialPaibanErr: '有板件具有特殊工藝或貼邊加工槽，暫不支持重新排版！',
    moreResult: '更多結果',
    moreResultTip: '大板中有貼邊加工的槽,大板將不會參與重新排版',
    batchBujian: '批量補件',
    batchOperation: '批量操作',
    batchEditPlankSize: '批量修改大板尺寸',
    editPlankSize: '修改尺寸',
    editWay: '修改方式',
    editByType: '按類型修改',
    editByPlankNumber: '按大板號修改',
    editContent: '修改內容',
    editContentTip: '請選擇需要修改的大板類型',
    editContentTip1: '請選擇需要修改的大板號',
    editStart: '起始',
    editEnd: '結尾',
    bigPlank: '大板',
    editSize: '尺寸修改為',
    bigPlankWidth: '大板寬度',
    bigPlankHeight: '大板長度',
    bigPlankLengthMarking: '大板長度標識',
    markedAs: '標識為',
    maxAddTen: '最多添加10個',
    minValue: '最小值',
    differentKnifeErr: '有不同下料刀的大板被選中，無法修改尺寸',
    noEditablePlank: '沒有符合條件的大板可修改',
    skipBrandPlankTip: '選中範圍內有{count}張品牌大板不支持修改尺寸，已跳過',
    nonBrandToBrandTip: '該小板不能拖動至品牌色卡大板!',
    brandToNonBrandTip: '該小板不能拖動至非品牌色卡大板!',
    brandToOtherBrandTip: '該小板不能拖動至其他品牌色卡大板!',
    editNo: '號',
    editAllPlank: '所有大板',
    editBigPartSize: '大板尺寸修改',
    disPlaySetting: '顯示設置',
    stored: '已入庫',
    onlySurplus: '只看餘料',
    UnuseSurplus: '餘料不參與利用率計算',
    usePlankAdsorption: '板件吸附功能',
    dataDefaultCollapsed: '數據默認收起',
    unit: '塊',
    cutSurplus: '切餘料',
    frontWarningTip: '雙面加工的高光板：先加工<span class="font-style">啞光面</span> , 再加工<span class="font-style">高光面</span><span>; &nbsp; 單面加工的高光板：直接加工 </span <span class="font-style">高光面</span>',
    selectTip: '請在下方選擇需要補件的小板!',
    plankKeyWordPlaceholder: '請輸入板件名稱或板號',
    surplusStoreSuccess: '入庫成功',
    editCutOrder: '修改切割順序',
    setCutPoint: '設置下刀點',
    specialPaibanChangeErr: '有板件具有特殊工藝或貼邊加工的槽，暫不支持切換排版方案！',
    storedSuccess: '補件成功！選中板件已經放入補件管理!',
    noSurplus: '未查詢到可用餘料',
    selectErrTip: '餘料板件不可補件,請先選擇正常小板',
    noRoomIDTip: '該板件沒有房間ID,無法進行補件入庫,請先選擇其他小板',
    noPlank: '未找到板件',
    noPaibanData: '無排版數據，無法進行',
    historyNameErr: '請輸入方案名稱',
    tempErrTip: '檢測到您未添加五/六面鑽所用模板，從而無法導出五/六面鑽加工文件,注意：添加完成後需要重新排版',
    changeDataTip: '注意：檢測到您的數據有變更是否新建一個歷史文件，保存此次變更內容？',
    upgrade: '升級',
    upgradeTip: '，您可以點擊下方按鈕去升級版本',
    plankOverEdge: '下載NC失敗！請檢查是否有板件重疊或板件在大板外',
    useSurplusTip: '是否扣減餘料',
    noDataExport: '沒有可以導出的排版數據',
    noPlankExport: '沒有可以導出的小板數據',
    lockTip1: '點擊進行解鎖，解鎖後可以',
    lockTip2: '編輯小板位置和屬性',
    unlockTip1: '點擊進行鎖定，鎖定後不可進行',
    unlockTip2: '小板位置和屬性的編輯',
    plankLockErr: '該大板已被鎖定無法放置',
    lockPartEditTip: '板件被鎖定，無法編輯',
    glassEquipmentTip: '生產線為玻璃切割機時，板件無法被移動',
    expandedTip: '板件存在拉槽特殊工藝，不支持編輯操作！',
    sameWidthPlankTip: '開啟了鋸片相同寬度排版,板件無法移動',
    expandedArrangeTip: '板件存在拉槽特殊工藝，需要重新排版！',
    dragErrTip: '無法放置, 請核對板件材質、顏色和厚度屬性!',
    subtleSaveTip: '當前已對板件操作但未保存,是否退出?',
    rollTip: '大板上存在通孔/通槽，不建議翻版！',
    glossRollErr: '高光板禁止翻板',
    lockDeleteErr: '板件被鎖定，無法刪除',
    deleteConfirmTip: '刪除操作不可恢復',
    deleteContinueTip: '你還要繼續嗎？',
    deleteConfirm: '請確認是否刪除',
    selectPlankTip: '請先選中板件再進行此操作',
    storeFailTip: '餘料入庫失敗！請檢查是否有板件重疊或板件在大板外',
    repeatStoreErr: '當前裁剪的餘料板件已經進行過入庫',
    surplusStoreFail: '入庫失敗, 請檢查板件是否為矩形或L形板件!',
    plankConfilictErr: '不支持在此處放置點位,將會和其他板件產生衝突',
    surplusErrTip: '不支持在此處放置點位,會產生一個錯誤的餘料',
    changeArrageSuccess: '成功切換排版方案',
    trialProduction: {
      trialProductionSample: '試生產樣品櫃',
      trialProduced: '我已試生產',
      trialWarning: '{fontStyleStart}若{fontStyleEnd}因您未進行樣品櫃的生產驗證，而造成對自身、他人及雲排版軟件的全部損失與不利後果將由您個人承擔全部責任',
      trialSlotTip: '試生產時請仔細檢測正反面孔槽的大小、深度、所在面、以及所在位置是否正確',
      trialSlotTip1: '避免出現櫃體鏡像',
      trialSlotTip2: '的問題',
      pleaseUploadTrial: '請上傳組裝好後的試生產樣品櫃照片',
      uploadTrial: '上傳樣品櫃'
      },
    awaitPlankStore: {
      store: '板件待排板庫',
      notTip: '不再提示未入庫',
      justLookCurrent: '僅看當前訂單小板',
      notInPushStorage: '未入庫',
      beInStorage: '已入庫',
      searchPlaceholder: '輸入訂單搜索待排版庫小板',
      plankUploading: '板件保存中',
      oneClickStorage: '一鍵存入待排板庫',
      notUsePlank: '暫無可用小板',
      notPlank: '無板件暫存',
      dragPlankInHere: '可將板件拖至此處進行板件暫存',
      surplusCannotBeStorage: '餘料不能入庫',
      plankHasBeenDeduction: '小板已被扣減或不存在原始數據，無法入庫',
      plankLoadErr: '板件信息加載失敗',
      taskTitle: '上傳待排版庫內板件',
      dataGenErr: '數據生成錯誤',
      pushSuccess: '入庫成功',
      pushErr: '出現未知錯誤，入庫失敗',
      awaitBoxExistPlank: '待排版庫存在未入庫小板，建議入庫後再操作！',
      pushAndOutput: '入庫並輸出',
      mergeFrameDoorWholeTip: '本部件為骨骼門整體組件，入庫後系統將自動拆解為單塊板件進行管理',
      checkPlankStatus: '正在校驗板件狀態...'
      },
    batchSetCut: '批量設置下刀點',
    applyTo: '適用於:',
    ncDownloadLifeText: {
      checkData: '正在檢測數據',
      checkDone: '數據檢測完成',
      checkDataText: '數據檢測',
      loadSetting: '正在加載設置',
      settingLoadDone: '設置加載完成',
      loadSettingText: '設置加載',
      downloadNc: '正在下載NC',
      ncDownloadDone: 'NC下載完成',
      downloadText: '下載NC',
      loadPreferenceSetting: '正在加載偏好設置',
      PreferenceSettingLoadDone: '偏好設置加載完成',
      loadPreferenceText: '加載偏好設置',
      dealTemp: '正在處理模板',
      TempDealDone: '模板處理完成',
      dealTempText: '處理模板',
      beBeingGenTagFile: '正在生成{fileType}文件',
      genTagFileDone: '生成{fileType}文件完成',
      genTagFileText: '生成{fileType}文件',
      zip: '正在生成本地壓縮文件',
      zipDone: '生成本地壓縮文件完成',
      genZipText: '生成壓縮文件',
      fileTypeText: '圖片'
      },
    surplusCommonTemp: '餘料常用模版',
    plankErrTip: '當前用料方案存在小板沒有可用大板進行排版!',
    brandPlankErrTip: '當前用料方案存在品牌小板沒有可用品牌大板進行排版!',
    overSizeTip: '大板數量不夠或超尺',
    uselessPart: '當前大板上無可用小板，請重新排版',
    splitArranged: '小板數量過多，請重新排版或分批次進行排版',
    arrangedErrTip: '排版失敗，存在大板數量不足或小板超尺',
    knivesModalTitle: '存在孔槽找不到刀具',
    cannotDownloadByKnivesErr: '無法下載NC，系統檢測存在以下孔槽找不到刀具',
    viewPart: '查看問題小板',
    deductionModalTitle: '請選擇扣減對象',
    bujianDeduction: '扣減補件小板',
    paibanDeduction: '扣減暫存區小板',
    surplusDeduction: '扣減餘料大板',
    unlockPaiban: '解除參與排版餘料的鎖定',
    maintain: '維持參與排版餘料的鎖定',
    lockModalText: '存在使用餘料大板被其他訂單佔用，是否重新排版',
    lockNewSModalText: '當前使用餘料大板被其他訂單佔用，是否繼續下載NC',
    rePaibanWarn: '餘料大板被其他訂單佔用，可用大板不足，請到開料清單重新排版',
    sawRePaiban: '注意：您使用的是鋸片切割，新增了異形板件排版，需要重新排版才可以輸出NC文件',
    togglePlankTip: '板件存在拉槽特殊工藝，不支持正反面切換操作！',
    stepCuttingMsg: '分層切割深度必須小於板件厚度',
    stepCuttingMsg2: '分層切割深度只能輸入大於0的數字',
    flipPlankTip: '已開啟孔槽分流開料機加工單面板，不允許翻板操作！',
    genNoCutTagNotSupportExportPic: '已開啟生成不下料板件標籤，暫不支持導出圖片',
    allSmallPlanksAreNoCutNotInLayout: '當前小板均為不下料板件，不參與排版',
    canStillExportHoleSlotOrPrintTag: '您仍可繼續導出孔槽加工文件，或打印標籤',
    desMaterialNoCutNotSupportSwitchLine: '當前生產線已開啟指定小板材質不下料，暫不支持直接切換生產線',
    desMaterialNoCutSettingChanged: '系統檢測到指定小板材質不下料的設置被修改，請重新排版確保生產準確',
    continueDownload: '繼續下載',
    desMaterialNoCutErrorTip: '指定小板材質不下料的板件中存在分配到雕刻機加工的孔槽/異形，本次下載孔槽/異形均分配到五六面鑽加工，是否繼續下載文件',
    clearReuseRelation: '點擊清除複用關係',
    layoutReuseTip: '快速複刻大板排版布局，板件變動自動解除複用關係',
    hasBeenReused: '已被複用',
    layoutReuse: '布局複用',
    specialProcessNotSupported: '板件存在特殊工藝，不支持此操作',
    conflictNotSupported: '板件存在衝突，不支持此操作',
    noAvailablePlankForReuse: '沒有可用的板件進行複用',
    noMatchingPlankFound: '未找到匹配的板件',
    reuseBoard: '{number}號大板複用',
    influenceTip: {
      title: '影響優化率功能',
      empty: '暫無',
      groupParams: '排版參數',
      surplusNoRoll: '餘料不翻板',
      surplusCustomTrim: '單獨設定修邊值',
      otherPlateCustomTrim: '特殊大板單獨修邊值',
      knifeDiameter: '下料刀',
      surplusNoFlip: '餘料不翻板',
      surplusNotLayout: '餘料大板不排指定板件',
      plankEdgeOff: '修邊',
      surplusCustomTrim2: '余料自定義修邊',
      other: '其他可能受影響的功能',
      enabled: '已開啟',
      plankThicknessStacking: '锯片厚度排版',
      edgePreMilling: '封邊預銑',
      multiMaterialCuttingBlade: '多材質下料刀',
      sawSpecialShapePart: '鋸切雕刻機的異形缺口板',
      longPlankCutting: '長板二次加工'
      }
    },
  paibanImg: {
    title: '排版圖管理',
    exportCustomPaibanImg: '匯出自定義排版圖',
    customPaibanImg: '自定義排版圖',
    isCustomName: '自定義排版圖名',
    template: '排版圖範本',
    addTem: '添加範本',
    canvasIndexSearch: '大板序號蒐索',
    symbol: '排版圖標識',
    frontSlot: '正面槽',
    backSlot: '反面槽',
    frontHole: '正面孔',
    backHole: '反面孔',
    printNum: '列印一張紙最多展示',
    printUnit: '張排版圖',
    edit: '排版圖範本編輯',
    temName: '範本名稱',
    rotate: '排版圖旋轉',
    showOverflow: '文字溢出板件時標識線展示小板數據',
    showHoleSlot: '展示孔槽資訊',
    bigPartCss: '大板排版圖樣式調整',
    partCss: '小板排版圖樣式調整',
    addTemTip: '最多只能添加10個排版圖範本！',
    exportTip: '請至少勾選一個排版圖範本匯出！',
    editSaveTip: '請確認必填項都填寫後，再保存！',
    exportDXF: '導出DXF',
    exportDxfGeneral: '二維通用 DXF',
    exportDxf3d: '三維專用DXF',
    exportDxfGeneralTip: '適用於手工加工看圖切割或檢查排版結果',
    exportDxf3dTip: '適用於導入第三方系統進行生產，已支持輝亞激光切割一體機'
    },
  historyPage: {
    matchErrBySpecialTip1: '以下特殊大板已無法找到匹配項，排版頁重新排版將會存在問題',
    specialPlankInfoErrTip2: '特殊大板信息獲取出錯，將影響排版頁重新排版功能',
    download: '下載本地',
    allType: '全部保存',
    handleSave: '手動保存',
    specialPlank: '特',
    surplusPlank: '余',
    autoSave: '自動保存',
    allArrange: '全部排版',
    searchPlaceholder: '搜索訂單名稱 / 排版批次 / 訂單號',
    saveHistoryName: '儲存歷史名稱',
    trailProduction: {
      title: '試生產樣品櫃',
      lastTime: '上次試生產日期',
      recordList: '試生產記錄',
      start: '開始試生產',
      date: '時間',
      outputFrom: '輸出位置',
      empty: '暫無數據',
      record: '上傳的試生產樣品櫃圖片記錄',
      tip1: '注意：當前試生產訂單使用的是默認生產數據',
      tip2: '注意：當前試生產訂單使用的並不是最新的工藝設置參數，可前往試生產房間重新保存！',
      download: '下載加工文件'
      },
    deleteTip: '是否確認刪除以下歷史記錄？',
    startDate: '開始日期',
    endDate: '結束日期',
    lastWeek: '最近一周',
    lastMonth: '最近一月',
    lastSeason: '最近三月',
    toArrangePage: '正在前往排版頁面',
    notArrangedTip: '該條記錄沒有進行過排版, 請先前往開料清單!',
    toMaterialPage: '正在前往開料清單頁面',
    lessSelectTip: '請至少選中一條記錄再進行此操作',
    downloadNc: '下載加工文件'
    },
  workShopPage: {
    warningTip: '該功能為限時試用，請合理安排您的訂單生產！',
    fileManager: '生產文件管理',
    selected: '已選中',
    suplement: '補件',
    size: '尺寸',
    saveToStore: '添加進補件倉庫',
    enterArrange: '正在進入排版...',
    deleteTip: '刪除該數據後不可恢復，是否確認刪除該數據？',
    arrangeTip: '正在解析補件數據,請稍等...',
    store: '補件倉庫',
    downloadFile: '下載生產文件',
    notBujianFile: '找不到補件文件',
    productLineDelete: '該生產線已被刪除,無法下載NC文件!'
    },
  basePlankManager: {
    saveTip: '注：按回車進行保存',
    offsetSize: '修邊尺寸',
    overSizeTip: '尺寸過大時，自動選用更大尺寸規格大板進行排版',
    addTip: '排版時如果板件超尺，彈出自動添加特殊大板彈窗',
    defaultOversizePlankValue: '設置超尺特殊大板的默認添加尺寸',
    onlyLayoutTooBig: '超尺大板只排超尺小板',
    settingRemark: '注：原此處功能調整到右側設置內',
    searchPlaceholder: '搜索板材材質/顏色',
    syncData: '同步櫃櫃數據',
    syncDataM: '同步櫃門數據',
    deletePlank: '刪除特殊大板',
    addPlank: '新建特殊板材',
    matCodePlaceholder: '請選擇板材',
    thickPlaceHolder: '請選擇厚度',
    widthErr: '板材寬度不能為空',
    heightErr: '板材長度不能為空',
    matCodeErr: '板材材質不能為空',
    colorErr: '板材顏色不能為空',
    editPlank: '編輯板材',
    deleteTip: '刪除該數據後不可恢復，是否確認刪除該數據？',
    plankKnifeSelect: '原片下料刀選擇',
    plankKnifeSelectTip: '當板件命中多條規則時，板材厚度優先級大於板材材質',
    knifeSelectTip: '注： 內嵌排版暫不支持此功能',
    knife: '下料刀具',
    matcodeInput: '請輸入板材材質',
    thickInput: '請輸入板材厚度',
    default: '系統默認',
    unessential: '此列為:非必填項',
    emptyTip: '注意：不填寫此項時匹配原片時將不區分此項數據！',
    defaultUse: '默認選用',
    editMatcode: '編輯材質',
    syncTip: '將獲取{fromMc}中數據並覆蓋現有雲排版中原片管理數據，是否同步？',
    sameErr: '已存在相同的數據',
    cancelDelete: '已取消刪除',
    syncErr: '同步失敗',
    syncSuccess: '同步成功',
    syncDataTip: '同步{fromMc}數據',
    editErrTip: '存在未填寫的信息, 請核對!',
    numberCheck: '{type}只能輸入數字!',
    deleteStandardPlate: '刪除標準板材',
    createStandardPlate: '新建標準板材',
    editStandardPlate: '編輯標準板材',
    trimmingDimension: '修邊尺寸',
    front: '上',
    back: '下',
    left: '左',
    right: '右',
    frontTrim: '上修邊',
    backTrim: '下修邊',
    leftTrim: '左修邊',
    rightTrim: '右修邊',
    customTrim: '自定義修邊值',
    trimValue: '修邊值',
    notEmpty: '{type}不能為空!',
    edgeDir: '修邊({type})',
    brandPlank: '品牌大板',
    brandPlankTip: '注：品牌大板刪除與修改在櫃櫃客戶端板材資源庫進行操作',
    brand: '品牌',
    supplier: '供應商',
    brandPlaceholder: '請選擇品牌',
    supplierPlaceholder: '請選擇供應商',
    brandInput: '請輸入品牌',
    supplierInput: '請輸入供應商',
    addBrandPlank: '新建品牌板材',
    deleteBrandPlank: '刪除品牌大板',
    editBrandPlank: '編輯品牌板材',
    searchBrandPlaceholder: '搜索品牌/供應商/板材材質/顏色'
    },
  bujianAndStore: {
    bujianStore: '補件倉庫',
    awaitStore: '板件待排版庫',
    depositAwaitStore: '存入待排版庫',
    pushToAwaitStore: '放入待排版庫',
    useTwoTableArrange: '使用兩個表單排版',
    confirmUseTwoTableTip: '當前選中小板包含補件庫和待排版庫小板是否繼續排版？',
    confirmAddPlankToAwaitStore: '是否確認將所選板件添加到待排版庫？',
    pushStoreSuccess: '入庫成功',
    dataGenErr: '數據生成錯誤',
    unknownErr: '出現未知錯誤，入庫失敗'
    },
  surplusPage: {
    surplusMaterial: '餘料清單',
    surplusStore: '餘料庫',
    recycleBin: '餘料回收站',
    recycleBinTip: '餘料數據放入回收站超過90天後會自動清除',
    "deleteReason-0": '手動刪除',
    "deleteReason-1": '排版扣減',
    "deleteReason-2": '櫃櫃移動端操作出庫',
    surplusShape: '餘料形狀',
    batchTransfer: '批量轉移',
    createNewSurplusStore: '新建餘料庫',
    pushStoreSetting: '餘料入庫設置',
    surplusStoreName: '餘料庫名',
    surplusStoreName2: '餘料庫名稱',
    addSurplusStore: '添加餘料庫',
    inventoryCeiling: '庫存上限',
    autoTransferTip: '刪除後餘料庫內餘料會自動轉移到餘料清單',
    asIndexPushStore: '按照倉庫存放情況順序入庫',
    pushToSurplusMaterial: '存入餘料清單',
    surplusStoreTable: {
      number: '編號',
      name: '餘料庫名稱',
      quantity: '已存餘料數量(個)',
      capacity: '餘料庫存上限(個)',
      rules: '餘料入庫規則',
      remark: '備註',
      operation: '操作'
      },
    editSurplusStore: '編輯餘料庫',
    addSurplus: '添加餘料',
    importSurplus: '導入余料',
    downloadSurplusTemplate: '下載余料導入模板',
    batchExportSurplus: '導出當前余料清單',
    surplusBatchImportExport: '余料批量導入導出',
    surplusMaterialStorageCode: '餘料入庫碼',
    generateQRCodeSuccess: '生成二維碼成功',
    generateQRCodeFailed: '生成二維碼失敗',
    refreshQRCode: '刷新二維碼',
    refreshQRCodeFailed: '刷新二維碼失敗',
    cancelRefresh: '已取消刷新',
    refreshQRCodeTip: '是否刷新二維碼，刷新後當前二維碼會失效。',
    refreshQRCodeConfirm: '確定',
    refreshQRCodeCancel: '取消',
    wechatScanTip: '打開微信掃碼可以手動添加餘料入庫使用',
    deletSurplus: '刪除餘料',
    editSurplus: '修改餘料',
    surplusNoRoll: '啟用餘料不翻板加工',
    type: {
      all: '全部形狀'
      },
    allMatcode: '全部材質',
    allThick: '全部厚度',
    surplusName: '餘料名稱',
    rectSurplus: '矩形餘料',
    LTypeSurplus: 'L形餘料',
    noMatchSup: '未查詢到相關數據',
    jumpTo: '跳至',
    page: '頁',
    newMatcode: '新建材質',
    newColor: '新建顏色',
    autoCreateColor: '按回車將自動創建色卡',
    nameLimit: '餘料名稱最多輸入10個字',
    nameLimitNameErr: '餘料名稱不能為空',
    tempLongTip: '板材長度只能輸入數字',
    minLongLimit: '短邊長度只能輸入數字',
    minLongEmptyTip: '短邊長度不能為空',
    minLongLimitMax: '短邊長度不能超過板材長度',
    widthLimit: '板材寬度只能輸入數字',
    minWidthLimit: '短邊寬度只能輸入數字',
    minWidthEmptyLimit: '短邊寬度不能為空',
    minWidthLimitMax: '短邊寬度不能超過板材寬度',
    thickLimit: '板材厚度只能輸入數字',
    thickEmptyLimit: '板材厚度不能為空',
    countInputLimit: '數量只能為正整數',
    countEmptyLimit: '數量不能為空',
    remarkMaxlimit: '備註最多輸入50個字',
    orderAddressMaxlimit: '來源訂單地址最多輸入100個字',
    orderIdMaxlimit: '來源訂單號最多輸入100個字',
    createTime: '添加時間',
    deleteTime: '刪除時間',
    deleteReason: '刪除原因',
    branchName: '所在餘料庫',
    orderAddress: '來源訂單地址',
    orderId: '來源訂單號',
    lockStatus: '鎖定狀態',
    lockOrder: '鎖定訂單',
    enableSurplusLock: '啟用餘料鎖定功能',
    isCloseSurplusLock: '功能關閉後所有餘料都會解除鎖定，是否繼續',
    confirm: '確認關閉',
    surplusTransfer: '餘料轉移',
    targetSurplusStore: '目標餘料庫',
    enableSurLockTip: '開啟後，每次排版都會鎖定使用的餘料，防止其他訂單佔用',
    addMainRule: '添加主規則',
    surplusRules: '餘料入庫規則',
    mainRulesTip: '主規則之間是或的關係，即只要滿足一個主規則，餘料就會入庫',
    mainRulesTip1: '添加規則後，命中規則的餘料會優先存放到該倉庫，該倉庫滿後會存入其他空閒餘料倉',
    rule: '規則',
    addSubRule: '添加子規則',
    subRuleTip: '子規則之間是且的關係，即需要同時滿足主規則下的所有子規則，才會入庫',
    bigPlankMatCode: '大板材質',
    bigPlankThick: '大板厚度',
    bigPlankColor: '大板顏色',
    greaterEqual: '大於等於',
    lessEqual: '小於等於',
    capNumberCheck: '庫存上限只能輸入整數!',
    capEmptyCheck: '庫存上限不能為空!',
    surNameEmptyCheck: '餘料庫名稱不能為空!',
    mainRuleLimit: '主規則已達上限',
    delMainRuleTip: '是否刪除本主規則',
    matCodeEmptyCheck: '大板材質不能為空!',
    thickEmptyCheck: '大板厚度不能為空!',
    textureEmptyCheck: '大板顏色不能為空!',
    enableWarehouseSecondCon: '啟用餘料入庫二次確認',
    surplusWarehouseConfirm: '餘料入庫確認',
    surplusWarehouseConfirm1: '入庫確認',
    closeSurplusConfirm: '關閉入庫確認（可在餘料管理頁面設定中重新開啟）',
    position: '存放位置',
    nameRepeatTip: '已存在當前餘料名，請修改後重新入庫',
    surLimitTip: '當前餘料庫已達上限或不滿足入庫規則',
    surFailTip: '入庫失敗，存在餘料名稱重複或餘料倉存放達到上限或不滿足入庫規則',
    surplusExistTip: '部分餘料板件已經在庫中，此次操作失敗',
    surplusExistTip2: '當前餘料板件已經在庫中，無法進行入庫',
    currentPage: '當前頁',
    totalPage: '全選所有'
    },
  printPage: {
    goto: '立即前往',
    surplusSizeTittle: '餘料尺寸過小提示',
    surplusSizeErrTip: '餘料尺寸過小，請前往對應生產線設置餘料最小尺寸！',
    opacityTip: '由智繪彩標提供技術支持',
    opacityTip2: '當前帳號未購買智繪彩標;如已購買,請在彩標軟體內綁定櫃櫃帳號',
    loadFontTip: '正在載入所需字體資源文件，請稍候',
    leftAlign: '左對齊',
    rightAlign: '右對齊',
    topAlign: '上對齊',
    bottomAlign: '下對齊',
    horizontalAlign: '橫向居中對齊',
    verticalAlign: '豎向居中對齊',
    horizontalSplit: '橫向均分',
    verticalSplit: '豎向均分',
    norTag: '常規原片標籤',
    surTag: '餘料大板標籤',
    genTag: '生成標籤',
    all: '全選',
    deleteWarning: '溫馨提示',
    print: '打印',
    defaultTemplate: '默認模版（60 x 40）',
    editTemplate: '編輯模板',
    deleteTip: '刪除該模板後不可恢復，是否確認刪除該模板？',
    tagSetting: '標籤設置',
    rememberSetting: '修改後將記住設置',
    genCutingTag: '生成裁剪板件標籤',
    genSurplusTag: '生成餘料標籤',
    genPlankTag: '生成大板標籤',
    genPartTag: '生成小板標籤',
    genNoCutTag: '生成不下料板件標籤',
    tagPosition: '貼標位置',
    tagPositionTip: '(貼標機才需填寫下方X/Y座標)',
    Xposition: 'X座標',
    Yposition: 'Y座標',
    genPlankSuffix: '大板標籤生成下料文件名後綴',
    arrangeMirror: '標籤圖鏡像',
    drillPlankBase: '五六面鑽放板基準',
    drillPlankBaseTip: '獲取放板基準數據錯誤，請稍後再試！',
    suitAuto: '標籤排序適應自動上下料：',
    colorLabel: '生成彩色標籤',
    colorRevert: '生成小板反色標籤',
    displayEnAndZh: '房間/櫃體/板件名展示中英文',
    displayEnAndZhTip: '僅支持默認的房間/櫃體名/板件名，修改為自定義名稱後該功能不生效',
    up: '向上',
    down: '向下',
    default: '默認',
    printSetting: '打印設置',
    oneToMore: '一張多頁',
    perPage: '每張',
    coloumn: '列',
    tagMargin: '標籤間隙',
    coloumnMargin: '列間距',
    specialMark: '特殊標記',
    opacity: '透明度',
    opacityTip3: 'BMP格式的圖片需要選擇真彩才支持透明度',
    suite: '自適應',
    svgListTip: '未開啟生成小板標籤，請在左側勾選',
    size: '大小',
    lightSide: '見光邊',
    locFrontSide: '櫃體前邊',
    openSide: '開門方向',
    extraTip: ' 提示：首次使用直接打印時，請在打印機設置中新增一張使用的該尺寸且長、寬對調的紙張，然後使用新增紙張進行打印（例：原紙張尺寸60×40，新增紙尺寸40×60） ',
    noMore: '沒有更多了',
    prepareData: '準備數據中...',
    genTagFile: '標籤生成中，請勿進行頁面切換、最小化瀏覽器、上下滾動標籤等操作！',
    waitGen: '請等待標籤加載完成後再進行下載',
    tempLoading: '標籤模板加載中,請稍後',
    front: '前',
    open: '開',
    toEdit: '前往編輯',
    simplifyOneCodeTip: '注意：此標籤模板設置的條形碼屬性不支持使用"簡易條碼"功能，請修改條碼屬性（推薦條碼屬性：CODE128）',
    plankTemp: '小板標籤模板',
    surplusTemp: '餘料標籤模板',
    enableSubTag: '開啟副標籤',
    enableSubTagTip: '可以在更多設置-小板副標籤設置-設置副標籤生成的生效數據源，開啟後只有設置的數據源在副標籤上有值，才會生成副標籤，反之則不生成副標籤',
    goSet: '去設置',
    mainTag: '小板主標籤',
    subTag: '小板副標籤',
    downloadSubTagTip: '導出的標籤帶副標，自動貼標生產線暫時無法生成副標，是否繼續輸出？',
    embeddedSubTagTip: '內嵌暫不支持副標籤功能，請打開網頁端雲排版後使用',
    subTagPerSaveTip: '副標籤權限已過期，請關閉副標籤後重新保存',
    subTagPerexportTip: '導出的生產文件包含付費的副標籤權限，該功能已過期需關閉後重新輸出',
    tempNamePlaceHolder: '請輸入模板名稱',
    editTip: '您可以根據自身需求拖動左側按鈕至右邊標籤紙上來完成標籤模板的編輯',
    oneCode: '條碼',
    image: '圖像',
    arrow: '箭頭',
    editPage: {
      digitLimitation: '位數限制',
      title: '標籤模版編輯',
      reset: '恢復默認',
      exit: '退出編輯',
      tagInfo: '標籤信息',
      tagName: '標籤名稱',
      tagSize: '標籤尺寸',
      tagData: '標籤數據',
      dragTip: '按住鼠標左鍵拖出數據標籤',
      dataTip: '請在右側屬性欄選擇數據信息',
      text: '文本',
      dataSource: '數據信息',
      graph: '圖形',
      typograpyPic: '排版圖',
      barCode: '條形碼',
      QRCode: '二維碼',
      plankMark: '板件標記',
      holeSlotPic: '孔槽圖',
      edgeBandPic: '封邊圖',
      visibleEdgePic: '見光邊',
      holeSlotPicZoom: '孔槽圖縮放',
      rotateDeg: '旋轉角度',
      colorDeep: '顏色深度',
      surplusMark: '餘料標識',
      surplusSizePic: '餘料尺寸圖',
      dataSize: '數據尺寸',
      extraList: '附加清單',
      QRCodeFormat: '二維碼格式',
      formatQR: 'QR格式',
      formatDM: 'DM格式',
      locIndex: '櫃體序號',
      plankFrontSign: '面板標記',
      genNCSuffix: '生成NC後綴',
      table: '表格',
      inputPlaceholder: '請雙擊輸入文本',
      attribute: '屬性',
      fontFamily: '字體類型',
      fontSize: '字體大小',
      fontWeight: '字體加粗',
      flipOverProcessing: '翻面加工',
      showSideMachiningSequenceDiagramBorder: '显示图例内框',
      showSideMachiningSequenceNumber: '显示数字加工顺序',
      autoRow: '自動換行',
      rowMargin: '行間距',
      autoFontSize: '溢出自動調整字體大小',
      statisticsDimension: '統計維度',
      noLimit: '不限',
      sameOrderNo: '同訂單',
      sameRoom: '同房間',
      sameWardrobe: '同櫃體',
      alignWay: '對齊方式',
      JustifyLeft: '居左對齊',
      JustifyRight: '居右對齊',
      JustifyCenter: '居中對齊',
      otherOpration: '其他操作',
      attributeReset: '參數重置',
      barCodeSize: '條碼尺寸',
      installPic: '安裝圖',
      plankCode2: '板件條碼(noMark)',
      frontCode: '正面條碼',
      backCode: '反麵條碼',
      orderRemark: '訂單備註',
      NCFileName: '下料文件名',
      NCFileNameTip: '下料文件名請勿包含中文且長度不可超過10位',
      showOpenSide: '顯示開門方向',
      limitFixed: '限制小數點位數',
      showFrontHS: '顯示正面孔槽',
      showBackHS: '顯示反面孔槽',
      showPartEdge: '顯示板件封邊',
      showPlankSize: '顯示板件尺寸',
      tempNamePlaceholder: '請輸入標籤名',
      deleteAreaTip: '請選擇要刪除的區塊',
      suitShunt: '適配孔槽分流設置',
      suitShuntTip: '勾選後,孔槽分流後無後道工序加工的孔槽板件便不生成條碼',
      noHoleSlot: '無孔槽也顯示條碼',
      rotate: '旋轉條碼',
      barcodeAtrribute: '條碼屬性',
      imgSize: '圖像尺寸',
      graphStyle: '圖形樣式',
      noEdgeDisplay: '封邊為0不顯示',
      allEdgeNoDisplay: '封邊不顯示',
      isShowDiffEdgeColor: '顯示各封邊顏色',
      hideSameEdgeColorAsPlank: '單邊顏色與板件相同时不顯示',
      hideSameEdgeColorAsPlankTip: '內嵌雲排版暫不支持',
      imgRotate: '圖片旋轉',
      circleD: '圓框直徑',
      roomNo: '房間編號',
      roomOrder: '櫃體序號（按房間排序）',
      alphabetically: '按字母排序',
      numberOrder: '按數字排序',
      specialMarkup: '特殊標記符號',
      smallPlateMarking: '小板標記',
      arrow: '箭頭',
      triangle: '三角角標',
      sixSideDrillPlankBase: '五六面鑽放板基準',
      boldSettingTip: '標籤PDF不支持',
      frontEdge: '顯示櫃體前邊',
      visibleEdge: '顯示見光邊',
      lineCount: '每行字數'
      },
    autoSaveToHistory: '已自動保存至歷史!',
    firstPrintTip: '首次使用直接打印時，請在打印機設置中新增一張使用的該尺寸且長、寬對調的紙張，然後使用新增紙張進行打印',
    tagDownloading: '標籤正在下載中...',
    cutLaveEnd: '餘料標籤在每張大板後面生成',
    deleteTemplate: '刪除模板',
    copyTemplateRenderUrl: '複製模板連結',
    noPermission: '導入模板中已關閉以下無權限功能',
    moreOperation: '更多操作',
    importTemplate: '導入模板',
    importTemplateLink: '將標籤模板連結地址粘貼至下方輸入框中，即可完成模板導入',
    importTemplateLinkPlaceholder: '請輸入模板連結',
    noDeleteTemplate: '默認模板不能刪除',
    tip1: '當前模板暫無可複製連結',
    tip2: '已複製當前模板數據連結。',
    tip3: '複製模板連結失敗，請稍後重試',
    tip4: '無法識別導入模板連結，請重新下載後導入'
    },
  fileManagerPage: {
    folderClassifyByTextureColorThickSize: '根據材質，顏色，厚度，大板尺寸歸為不同文件夾(貼標文件一起)',
    notOpeFolderPermission: '未授權操作此目錄',
    notFindFolder: '無法在當前客戶端檢測到此目錄',
    productLineUniversal: '所有生產線通用',
    effectCondition: '此設置更改後需重新排版才可生效',
    addPath: '添加路徑',
    downloadPositionChangeByType: '生成文件下載位置已更換為{type}',
    isDeleteFolder: '是否確認刪除使用過的文件存儲位置?',
    netWorkIsNotSafe: '您的網絡環境似乎不安全，我們無法啟用此功能，您可以反饋給我們',
    NotSupportBrowse: '您的瀏覽器暫不支持此功能，請下載最新版<a href="https://www.microsoft.com/zh-cn/edge/download" target="_blank" >Edge</a>瀏覽器使用',
    notSupportDisk: '不可選用系統級別目錄,如【桌面】【C盤】',
    useFolderDownload: '生產文件以解壓後的形式下載',
    downloadPosition: '下載文件位置',
    changeUseFolder: '更改',
    folderNameSetting: '文件夾設置',
    mainFolder: '一級文件夾',
    exportNameSetting: '導出加工文件按訂單號命名',
    fileMax: '文件名最多為',
    char: '字符',
    overTip: '超過部分不顯示（標籤圖壓縮包和json文件將跟隨一級文件夾命名） ',
    example: '樣例',
    engravingFolder: '雕刻機文件夾',
    electronicSawFolder: '電子鋸文件夾',
    labellingFolder: '貼標機文件夾',
    sideHoleDrillFolder: '側孔機文件夾',
    fiveDrillFolder: '五面鑽文件夾',
    sixDrillFolder: '六面鑽文件夾',
    PTPFolder: 'PTP文件夾',
    labellingTagFolder: '貼標圖片文件夾',
    surplusFolder: '餘料文件大板設置',
    surplusBigPlankSetting: '餘料大板下料文件/標籤圖片/貼標文件單獨放置',
    surplusBigPlankSettingTip: '開啟後餘料的NC文件，標籤圖片和貼標文件會單獨放在一個文件夾裡',
    folderMergeSetting: '文件夾合併設置',
    folderMerge: '文件夾合併',
    mergeName: '合併名稱',
    subMergeFolder: ' 按照材質顏色厚度合併到子文件夾',
    subFolderName: '子文件夾名稱',
    splitChar: '分割符',
    splitTip: '（不支持輸入 / : ? < > | . ” * 等字符）',
    folderAutoAdd: '文件夾數自增起始數值',
    resetTip: '(每日零點重置為起始數值)',
    emptyErrTip: '信息不能為空',
    repeatErrTip: '文件名稱重複',
    mergeDataTip: '必須存在板件材質顏色厚度長寬或者文件數自增或者板件材質顏色厚度',
    engravingFileSetting: '雕刻機文件設置',
    engravingSplitZF: '將雕刻機正/反面文件用不同文件夾放置',
    engravingSplitZFTip: '適用於壹貳叄自動貼標機，',
    engravingSplitWorkstation: '雕刻機按工位分文件夾',
    engravingSplitWorkstationTip: '注：僅支持雕刻機和鋸切雕刻機',
    holeFileSetting: '打孔文件設置',
    holeFileSingle: '打孔文件按不同訂單分文件夾單獨放置'
    },
  moreSettings: {
    generalSetting: '通用設定',
    outSyncTip: '雲排版原片數據與櫃櫃不同步時生成提示彈窗',
    secondarySwitchShow: '雕刻機設定中開關控制的二級內容關閉開關後依舊展示',
    isFrameDoorTip: '骨骼門加工時生成提示彈窗',
    exPaibanTip: '使用異形餘料/異形嵌套排版時生成提示彈窗',
    isDesMaterialNoCutTip: '指定小板材質不下料的板件，有分配到雕刻機的孔槽/異形時生成提示彈窗',
    surpTagThresholdTextHalf1: '當餘料（非裁剪餘料）面積小於',
    surpTagThresholdTextHalf2: '不生成餘料標籤',
    innerShapeToolMatch: '雕刻機加工內部異形自動選擇合適刀具',
    innerShapeToolMatchTip: '（雕刻機加工比下料刀直徑小的內部異形，出現尺寸錯誤無法加工的情況時可啟用此功能）',
    innerShapeToolMatchTip2: '注意：啟用後將會使用最小銑槽刀，請合理設定最小銑槽刀的"刀具長度"和"單次最大加工深度"，僅在雲排版生效',
    surNotLayout: '定義餘料大板不排指定板件',
    surNotLayoutTip: '開啟後1.餘料大板不能排小板名稱包含下方名稱的小板 2.在排版時可以選擇本次排版是否生效該功能',
    addPlank: '添加板件名',
    addPlankTip: '至少添加一個小板名稱',
    thisInput: '這裡輸入',
    surNotLayoutMat: '餘料不排指定小板',
    subTagSetting: '小板副標籤設置',
    subTagDataSource: '設置副標籤生成的生效數據源',
    subTagDataSourceTip: '開啟後可以把控制副標籤生成的數據源添加進來，當副標籤上有該數據源時，且數據源存在值時，就會生成副標籤',
    addSubTagDataSource: '添加數據源',
    addSubTagDataSourceTip: '不允許添加重複數據源',
    addSubTagDataSourceTip1: '請至少添加一個數據源',
    addSubTagDataSourceTip2: '數據源不能為空，請選擇',
    reuseMatchingPlankName: '布局復用匹配板件名稱',
    reuseMatchingPlankNameTip1: '此功能關閉時，佈局復用功能匹配材質、顏色、厚度、長寬、紋理、高光屬性相同的小板',
    reuseMatchingPlankNameTip2: '開啟此功能時，除上述的匹配條件外，還將增加板件名稱的匹配'
    },
  lineManager: {
    add: '添加生產線',
    engraving: '開料設備',
    holeSlotEquip: '孔槽加工設備',
    workSetting: '加工設置',
    noUse: '未啟用',
    warningTip: '* 注意：下列功能設置後，後續請不要在櫃櫃客戶端設備對接頁面進行保存，避免參數重置！',
    engravingSetting: '雕刻機設置',
    workWay: '加工方式',
    cutedSpecial: '加工的特殊孔槽：',
    noWork: '此選項對五/六面鑽默認模板不生效',
    onlyCut: '僅下料',
    onlyFrontHoleSlot: '僅加工板件正面孔槽',
    onlyHoleSlot: '僅加工板件正反面孔槽',
    sideHoleSetting: '側孔機設置',
    cutHoleSlot: '加工的孔槽',
    minSize: '短邊尺寸',
    maxSize: '長邊尺寸',
    minSize2: 'mm的板上的所有孔槽和異形部分',
    minSize3: '和異形部分',
    onlyFrontHoleSlotTip: '排版頁僅正面有孔槽的小板',
    onlyFrontHoleSlotTip2: '不包含側孔槽',
    holeAndSlot: '孔和槽',
    empty: '空',
    singleHole: '單孔',
    singleSlot: '單槽',
    diameterRange: '孔直徑範圍',
    hDeepRange: '孔深度範圍',
    widthRange: '槽寬度範圍',
    sDeepRange: '槽深度範圍',
    to: '到',
    specialHS: '特殊孔槽和異形',
    allowRoll: '允許雕刻機翻版加工特殊孔槽',
    engravingPath: '雕刻機上加工板件異形部分',
    curve_range: '異形部分長邊大於',
    curve_range2: '的板件所有異形部分',
    curveArea: '異形面積',
    drillSetting: '五六面鑽設置',
    engravingCuted: '雕刻機上已加工孔槽在五/六面鑽上',
    engravingCutedSpecial: '雕刻機上已加工的異形部分在五/六面鑽上',
    genCuttingPath: '生成切割數據',
    otherCuted: '其他設備已加工的孔槽在五/六面鑽上',
    noGen: '不生成',
    genCut: '生成並加工',
    genNoCut: '生成但不加工',
    cutTip: ' 注：此選項僅對自定義的五六面鑽文件生效',
    maxShortSize: '最大短邊尺寸',
    maxLongSize: '最大長邊尺寸',
    normalSlot: '普通槽',
    specialSlot: '特殊槽',
    combinSetting: '組合設備設置',
    allowShortSize: '允許短邊尺寸',
    equipment1: '設備一',
    equipment2: '設備二',
    noSameTip: '注：兩個設備不能選擇一樣',
    workRange: '設備一可加工孔槽範圍',
    rangeWarning: '注：僅可設置設備一加工範圍，非設備一加工範圍將全部在設備二上加工，請謹慎操作！',
    deleteWarning: '刪除該生產線後不可恢復（該生產線下所有設置都將刪除），是否確認刪除該生產線？',
    top: '頂部',
    inputCheck: '{msg}最小值不能大於最大值',
    lockTip: '生產線已鎖定,禁止操作!',
    reNameTip: '默認生產線不可修改名字',
    permissonTip: '身份信息已過期,請重新從櫃櫃打開此頁面!',
    permissonErr: '暫無此權限, 請升級賬號版本!',
    permissionOneMacErr: '您當前可使用的一體機生產線條數為{idx}條，如需增加，請聯繫銷售人員！',
    permissionSawErr: '沒有鋸切雕刻機使用權限，請聯繫銷售購買全鋁鋸切補充包後使用',
    getAuthError: '獲取設備權限失敗！',
    sawAddNumber: '您當前可使用的電子鋸生產線條數已用完，如需增加，請聯繫銷售！',
    newLine: '新建生產線{idx}',
    deleteCheck: '不能全部刪除',
    deving: '開發中',
    combinTip: '請點擊下方組合設備設置進行設置',
    noUseEquip: '未啟用加工設備',
    equipmentSelectTip: '組合設備選擇了雕刻機時，開料設備不能選擇電子鋸',
    lineLoading: '數據加載中',
    strenchType: '拉直器槽類型',
    aioProcessTip: '您已啟用"一體機"設備，加工方式默認為加工板件正反面孔槽',
    aioProcessTip2: '啟用一體機後在雕刻機部分加工的特殊孔槽',
    aioProcessTip3: '注意：該功能不兼容啟用XY軸互換的雕刻機 請謹慎使用',
    specialHoleTip: '注意：使用以上"加工的特殊孔槽"的功能時請將"通孔打孔方式"和"通槽打穿方式"設置為一次打穿',
    specialHoleTip2: '注意：使用以上"加工的特殊孔槽"的功能時請將雕刻機"通孔打孔方式"和"通槽打穿方式"設置為一次打穿',
    fiveSixNotTake: '此選項對五/六面鑽默認模板不生效',
    onlyFrontSide: '僅加工正面',
    onlyBackSide: '僅加工反面',
    less: '小於',
    equal: '等於',
    greater: '大於',
    or: '或',
    and: '且',
    bothFrontBack: '加工正面和反面',
    shareDataErrTip: '此條數據由{operatorPhone}應用,ip:{actionIp}',
    restoreParams: '還原參數',
    loadMore: '加載更多',
    currentCombinationEquipment: '當前選擇組合設備，開料設備不允許切換到玻璃切割機',
    selectEquipmentType: '請選擇設備類型',
    ruleRemark: '規則備註',
    remarkPlaceholder: '這是一個備註信息，可以備註這條規則加工哪些工藝，避免遺忘',
    onlyNoSideHoleSlotSmallPlank: '僅無側孔側槽小板'
    },
  cuttingDock: {
    title: '開料對接',
    autoStockCode: '自動上下料代碼',
    stationStart: '工位開始',
    stationStartCode1: '工位1開始代碼',
    stationStartCode1Placeholder: '輸入工位1開始代碼',
    stationStartCode2: '工位2開始代碼',
    stationStartCode2Placeholder: '輸入工位2開始代碼',
    stationEnd: '工位結束',
    stationEndCode1: '工位1結束代碼',
    stationEndCode1Placeholder: '輸入工位1結束代碼',
    stationEndCode2: '工位2結束代碼',
    stationEndCode2Placeholder: '輸入工位2結束代碼',
    frontBackStart: '正反面開始',
    frontBackEnd: '正反面結束',
    frontStartCode: '正面開始代碼',
    frontStartCodePlaceholder: '輸入正面開始代碼',
    frontEndCode: '正面結束代碼',
    frontEndCodePlaceholder: '輸入正面結束代碼',
    backStartCode: '反面開始代碼',
    backStartCodePlaceholder: '輸入反面開始代碼',
    backEndCode: '反面結束代碼',
    backEndCodePlaceholder: '輸入反面結束代碼',
    plankStart: '板件翻面開始',
    plankEnd: '板件翻面結束',
    plankRollCode1: '工位1翻面代碼',
    plankRollCode1Placeholder: '輸入工位1翻面代碼',
    plankRollCode2: '工位2翻面代碼',
    plankRollCode2Placeholder: '輸入工位2翻面代碼',
    autoBaitingCode: '自動下料代碼',
    autoBaitingCode1: '工位1下料代碼',
    autoBaitingCode1Placeholder: '輸入工位1下料代碼',
    autoBaitingCode2: '工位2下料代碼',
    autoBaitingCode2Placeholder: '輸入工位2下料代碼',
    thickMarkPermission: '您當前無大板厚度標識權限，請聯繫銷售購買後使用',
    thickMark: '大板厚度標識',
    preStartEquipment: '預啟動設備',
    firstKnifePreCode: '首刀預啟動代碼提前',
    secondKnifePreCode: '第二把刀及後續刀預啟動代碼提前',
    rowInsert: '行插入',
    pumpPause: '真空泵暫停',
    pumpPauseTip: '注意：單工位設備需要將工位1和工位2都填上相同的"自動上料代碼" 和"雙面加工正面註釋代碼"',
    pumpPause2Tip: '注意：單工位設備需要將工位1和工位2都填上相同的"真空泵暫停代碼"',
    pumpPauseCode1: '工位1真空泵暫停代碼',
    pumpPauseCode1Placeholder: '請填寫工位1的真空泵暫停代碼',
    pumpPauseCode2: '工位2真空泵暫停代碼',
    pumpPauseCode2Placeholder: '請填寫工位2的真空泵暫停代碼',
    annotationCode1: '工位1雙面加工正面註釋代碼',
    annotationCode1Tip: '適用於自動上料正面不同指令的設備',
    annotationCode1Placeholder: '輸入工位1雙面加工正面註釋代碼',
    annotationCode2: '工位2雙面加工正面註釋代碼',
    annotationCode2Placeholder: '輸入工位2雙面加工正面註釋代碼',
    upSpeedTip: '請填寫共邊加速速度',
    cutThickTip: '請填寫共邊切割厚度',
    sizeErrTip: '請在貼標機中設置導出排版圖的正確尺寸!',
    offEdgeKnifeDiameter: '請輸入修邊刀具直徑',
    slowDownSpeedTip: '切割轉角減速輸入參數錯誤',
    permissionErr: '當前為免費版, 無法保存',
    labellingTempErr: '請選擇貼標機模板',
    autoRollInputTip: '開啟標籤自動旋轉，需輸入有效值',
    offlineTempFormat: '當前貼標機文件格式已下線, 請確認',
    autoStockCode1: '工位1自動上料代碼',
    autoStockCode1PlaceHolder: '輸入工位1自動上料代碼',
    autoStockCode2PlaceHolder: '輸入工位2自動上料代碼',
    autoStockCode2: '工位2自動上料代碼',
    pauseCode: '暫停代碼',
    pauseCodePlaceHolder: '輸入暫停代碼',
    cuttingToolMaxDepthTip: '刀庫{errKey}刀中單次最大加工深度不能大於刀具長度',
    cuttingParams: {
      title: '切割參數',
      stationWidth: '台面寬度',
      stationWidthTip: '使用餘料大板時，寬度方向只能在設置的尺寸範圍內排小板',
      holeSlotMainSide: '孔槽集中面',
      holeMainSide: '孔集中面',
      slotMainSide: '槽集中面',
      workPriority: '(功能優先級：打穿孔槽所在面跟隨該小板上未穿孔槽>拉直器和鉸鏈杯孔放在大板反面加工>孔槽分流中設置的特殊孔槽優先排在大板正面>槽集中面>孔集中面)',
      holeSlotSet: '打穿孔槽加工設置',
      hingeRollWork: '拉直器和鉸鏈杯孔放到大板反面加工',
      followWork: '打穿孔槽所在面跟隨該小板上未穿孔槽',
      autoMatchSide: '按比例分配正反面孔槽',
      backHSRate: '反面孔槽佔比',
      matchTip: '高光板、開啟計算異形或對紋的排版方案都不會生效此設置',
      specIalHoleAndSlotSurface: '特殊孔槽加工面自訂',
      specialRuleTip: '請選擇特殊孔槽',
      specialSlotsHoles: '孔槽類型',
      holeType: '孔類型',
      specialRules: '規則',
      normalHole: '常規孔',
      normalSlot: '常規槽',
      holeDiam: '孔直徑',
      slotLongSide: '槽長邊',
      slotShortSide: '槽短邊',
      FixedmachSurface: '固定加工面',
      deleteRuleTip: '是否刪除該規則',
      blankFront: '大板正面',
      blankBack: '大板反面',
      addRules: '新增規則',
      addRulesTip: '當同一塊小板命中多個規則時，生效序號最靠前的規則，可拖曳任意行改變規則順序',
      highGlossSetting: '高光板設置',
      heighGlossFront: '排版時小板高光面排在大板',
      highGlossPlankNoRotate: '高光板不轉板',
      highGlossAutoRoll: '僅帶有反面孔槽的大板自動翻面',
      highGlossAutoRollTip: "<span class='color-o-4'>（啟用後僅反面孔槽的大板排版時將會自動翻面，變為單面板。配合自定義文件名\"高光面翻面放板\"數據使用）</span>",
      customHighGlossReverse: '高光面翻面放板',
      sideSlotPut: '靠邊板槽放置',
      optimize: '功能優化中',
      sysDefault: '系統默認',
      plankInSide: '大板內側',
      plankOutSide: '大板外側',
      specialNotWork: '該功能不對異形板件生效',
      commonSide: '共邊切割',
      commonSetting: '共邊設置',
      plankThickRange: '板件厚度小於等於',
      useCommonSide: '時採用共邊切割',
      zeroTip: '排版間隙需手動改為0，加工至已切割邊時抬刀跳過該邊，此功能開啟後，將不支持斜下刀加工，請注意！',
      useTip: '此功能開啟後，將不支持斜下刀加工，請注意！',
      commonSpeed: '共邊加速',
      highSpeed: '高速擦銑速度',
      min: '分鐘',
      notWorkTip: '當板材加工滿足共邊切割時，共邊加速則不生效',
      changeStartPoint: '雙工位起始點切換',
      changeStartPointTip: '啟用雙工位起始點切換後，與XY軸互換功能不兼容，請謹慎使用',
      flatOffset: '機台平面偏移',
      xRowChange: 'X軸坐標基準對調',
      bigplankPointChange: '大板反面坐標基準對調',
      reverseXRowChange: 'X坐標對調',
      changebigplankPointTips: '啟用該功能後與"XY軸互換、雙工位起始點切換"功能不兼容，請謹慎使用',
      reverseYRowChange: 'Y坐標對調',
      plankMirrorTip: '在開料機上加工的板件鏡像時使用此功能',
      notSameSize: '雙工位台面不同尺寸',
      maxSize1: '工位一最大尺寸',
      notSameSizeTip: '啟用雙工位台面不同尺寸後，與雙工位文件合併功能不兼容，請謹慎使用',
      maxSize2: '工位二最大尺寸',
      autoSelectTip: '雙工位設備兩個台面尺寸不同時使用此功能將會自動選擇對應工位加工大板',
      bigFlatLimit: '大工位只加工小工位無法加工的大板：',
      surplusSetting: '餘料設置',
      surplusPosition: '餘料擺放位置',
      cutHoleWay: '切割打孔方式',
      knifeFlat: '對刀基準面',
      flat: '台面',
      plankFlat: '大板表面',
      freeHeightZ: '空閒時Z高度',
      relativeHeight: '相對大板上表面高度',
      cutDeepZ: '切透量Z深度',
      cutDeepH: '通孔打孔方式',
      setDisableDoubleSidedThroughHole: '設置不生效翻面兩次打穿孔',
      addHolesToRulesDisableDoubleSided: '將對應通孔（打穿的孔）添加到下方規則後，不生效翻面兩次打穿',
      onceThrough: '一次打穿',
      rollThrough: '翻面兩次打穿',
      cutDeepS: '通槽打穿方式',
      plankCutDirection: '小板切割方向',
      clockDirSwitch: '自定義銑孔銑槽/內部異形切割方向',
      millHoleSlotDir: '銑孔銑槽方向',
      millInternalCurveDir: '內部異形切割方向',
      sDirection: '順時針',
      nDirection: '逆時針',
      curveReplenish: '圓弧插補指令切割弧形板',
      curveReplenishTip: '弧形板件切割出現鋸齒時可選用該功能',
      noGen: '不生成G17/G18/G19面指令',
      arcInstruction: '圓弧插補指令前綴',
      example: '示例',
      arcExample: 'G17G03 X100 Y100',
      curveCutTip: '圓弧切割用I、J表示',
      coverRate: '銑槽時切割重疊率為：',
      roughTip: '刀具銑槽時槽內部有餘留毛刺時使用該功能',
      clearCurve: '銑槽時未拉穿的槽自動清理圓角：',
      curveUseTip: '在銑槽時需要清理圓角選用此功能，注意該功能不對連接件生效',
      slotCutWay: '銑槽走刀方式',
      outToIn: '從外向內銑槽',
      inToOut: '從內向外銑槽',
      zShapProcess: '通槽上下Z字形銑槽',
      zShapProcessTip: '僅針對前後拉透通槽銑槽生效，刀路徑重疊率默認為刀半徑',
      zSlotCuttingOverlapRate: 'Z字形銑槽切割重疊率為',
      zSlotCuttingOverlapRateTip: '當前重疊率可能导致加工速度变慢，请试机后再加工。',
      slotWorkLimit: '(僅在銑槽走刀層數>1時生效)',
      minKnifeChange: '加工减少換刀',
      preventBreakage: '邊緣槽隔條防斷',
      preventBreakageTip: '該設置僅對排版時位於正面的槽有效，可與「特殊孔槽加工面自定義」功能配合使用',
      preventBreakageTip1: '可解決槽位若過於靠近板材邊緣，切割時該處的隔斷條（即剩餘連接部分）會因應力集中而容易斷裂的情況',
      preventBreakageDistance: '距板件邊緣',
      preventBreakageLength: '靠邊部分長度',
      preventBreakageSlot: '的槽',
      preventBreakageCutDeep: '首次切削深度',
      workSpeedOp: '加工速度優化',
      obliqueCut: '切割時斜下刀',
      obliqueCutTip: '未指定板厚時，則對所有板厚小板生效',
      obliqueThickLabel: '自定義斜下刀生效板厚',
      obliqueThick: '自定義斜下刀生成的板件厚度',
      backObliqueThick: '自定義反面修边斜下刀的板件厚度',
      effectiveThickness: '生效厚度',
      effectiveThicknessTip: '生效厚度不能為空，請輸入！',
      effectiveThicknessDuplicateTip: '生效厚度不能重複，請修改',
      obliqueCutData: '斜下刀距離',
      backOblique: '反面修邊斜下刀',
      obliqueSpeed: '斜下刀速度',
      obliqueSpeedTip: '切割下料和反面修邊',
      arcSpeed: '曲線加工速度',
      cuttingPreDistance: '下刀提前距離',
      backKnife: '切割收刀減速',
      openKnifeSpeed: '收刀速度',
      retractionCompensation: '切割收刀距離補償',
      retractionCompensationTip: '最大值20',
      cutCornerSlow: '切割轉角減速',
      addRow: '新增',
      bettwenDistance: '轉角前後距離',
      cuttingSpeed: '切割速度',
      stepCutting: '分層切割',
      splitSlot: '槽切割兩次',
      splitPlank: '的小板切割兩次',
      splitPlank2: '小板切割兩次',
      minSafeThick: '厚度大於',
      splitPlankTip: '（異形板件不生效此功能）',
      splitPlankTip2: '（不兼容：收刀補償）',
      cutPlankMethod: '切板方式',
      cutPlankMethodTip: '四邊切兩次',
      cutPlankMethodTip2: '僅最後一條邊切兩次',
      specialShapCut: '異形板件切兩次',
      specialShapCutTip: '（啟用後所有異形板件都會切兩次）',
      bridgeRetention: '搭橋留點法',
      bridgeRetentionTip: '（注意：1、該功能暫不支持外部異形板  2、不支持斜下刀  3、生成連接橋板件最小尺寸30mm）',
      bridgeRetentionDesc: '可解決當板件內部存在大量挖空區域時，切割路徑容易因支撐不足而導致板材抖動或跑板的情況',
      bridgePunchArea: '打穿部分超過總面積',
      bridgeSize: '連接橋尺寸',
      bridgeGenMethod: '生成方式',
      bridgeAddTip: '最多添加10條數據',
      bridgeCount: '連接橋數',
      bridgePlankLength: '板件長度(L)',
      maxWH: '長或寬小於',
      areaLimit: '且面積小於',
      secondDeep: '第二次切割深度',
      splitPlankThickSetting: '開料分層切割設置',
      saveCustomSpeedTip: '加工速度不能為空',
      saveLayeredCuttingTip: '開料分層切割三次分層切割的總和必須等於板件厚度',
      saveLayeredRepeatTip: '開料分層切割不建議同一個材質高光屬性厚度設置不同的分層數據，請刪除多餘數據！',
      splitPlankThick: '不同板厚分層切割',
      movePlankSetting: '防跑板設置',
      newCutSequence: '新版切割算法',
      newCutSequenceText: '默認大板中心真空吸力最強，此塊區域小板最後切',
      positionTip: '點擊相應區域可以進行選擇',
      suctionPosition: '真空強吸力位置',
      strongArea: '強吸力區',
      minSuctionPlank: '最小可吸住板件',
      safeWidth: '寬度',
      safeHeight: '長度',
      safeTip: '吸不住板件會先切',
      scattered_layout: '小板分散排版',
      lastCutPointEnable: '大板上最後切割小板下刀點自定義',
      lastCutPointEnableTip: '啟用後每塊大板上最後切割的小板下刀點會按照設置的點位生成下刀點',
      lastCutPoint: '下刀點位置',
      lastCutPointTip: '開啟後，每塊大板最後切割的小板將使用此下刀點',
      leftTop: '左上角',
      rightTop: '右上角',
      leftBottom: '左下角',
      rightBottom: '右下角',
      specifyTheMaterial: '指定材質',
      shapeSecondCutenable: '異形板二次切割',
      addMaterial: '新增材質',
      plankMaterial: '板件材質',
      specifyTheMaterialTip: '啟用後滿足表格材質的板件才會生效二次切割功能',
      dispersePaibanTipOne: '1、啟用後每張大板上會至少一張滿足最小可吸住尺寸的板件',
      dispersePaibanTipTwo: '2、注意使用後可能會增加大板量',
      totalThickLimit: '三次分層切割的總和必須等於板件厚度',
      offsetFollowStep: '修邊也跟隨分層切割',
      longPlankTip1: '1、開啟或關閉此功能後保存歷史中的排版記錄在下載NC時需進行重新排版',
      longPlankTip2: '2、啟用該功能後必須在【開料對接-真空泵暫停】中設置真空泵暫停代碼，否則無法解決長板切割彎曲的問題',
      longPlankTip3: '3、下方已開啟的篩選條件按層級依次校驗，只有滿足上一級篩選條件的板件，才可進入下一級篩選條件進行判定',
      secondCutting: '二次切割對象',
      normalPlank: '的常規板',
      normalPlankTip: '常規板：櫃體中橫豎隔板等非櫃門的板件和開料清單中直接添加的板件',
      designatedTarget: '指定對象',
      filterLevel1Label: '一級篩選',
      filterLevel1Category: '板件類型',
      filterLevel2Label: '二級篩選',
      filterLevel2Category: '尺寸限制',
      filterLevel3Label: '三級篩選',
      filterLevel3Category: '其他',
      specifiedBoardForceEnable: '忽略尺寸/其他篩選條件，強制啟用',
      curveMaterialFilterTip: '（勾選「異形板」後，板件必須先滿足為異形板件的前置條件，才可進入後續材質篩選環節進行判定）',
      cuttingSettings: '切割設置',
      plankSizeLimitSuffix: '的板件',
      specifiedBoard: '指定板名切割',
      specifiedBoardTip: '開啟後當板件名稱中包含下方添加的板件名則生效二次切割',
      addPlankName: '添加板件名',
      plankNameEmpty: '板件名不能為空，請輸入',
      plankNameRequired: '請至少添加一個板件名',
      plankLongLimit: '當長板長邊超過',
      plankShortLimit: '短邊超過',
      cuttingSplit: '分兩次切割',
      longExpand: '首次切割放量：長邊放量',
      firstExpand: '首次切割放量',
      longExpandTip: '長邊放量',
      longLimit: '長邊超過',
      cuttingSplitTip: '長板分兩次切割條件',
      shortExpand: '短邊放量',
      expandTip: '長/短邊尺寸各增加X mm，異形長板長短邊放量皆為長邊放量值',
      pumpOffWay: '真空關閉方式',
      afterOnePlank: '單塊長板切割後',
      afterAllPlank: '整張大板切割後',
      numberFixed: '小數保留位數',
      bufferCode: '下刀緩衝指令設置',
      layoutGap: '排版間隙設置',
      layoutGapTip: '注意：排版間隙設置為0可能會出現排版重疊',
      wasteCutting: '廢料自動截斷',
      zkPointCustomize: 'Z扣斜孔加工旋轉基準點自定義',
      sawSetting: '鋸切設置',
      cuttingLimit: '截斷尺寸大於',
      waste: '的廢料',
      wasteSizeLimit: '最小尺寸不得小於100mm',
      topLeft: '左邊、上邊',
      topLeftD: '左上角',
      bottomLeft: '左邊、下邊',
      bottomLeftD: '左下角',
      topRight: '右邊、上邊',
      topRightD: '右上角',
      bottomRight: '右邊、下邊',
      bottomRightD: '右下角',
      firstTime: '第一次',
      secondTime: '第二次',
      thirdTime: '第三次',
      startCutting: '切割開始',
      thickRange: '厚度 ≥',
      longCut: '長板加工',
      edgeSetting: '修邊設置',
      cuttingOrder: '切割順序：',
      cuttingOrderTip: '此方式存在跑板風險，請謹慎使用',
      plankFirst: '先切小板',
      wasteFirst: '先切廢料',
      offTip: '關閉時將跟隨切割參數中修邊設置',
      edgeCutDirection: '修邊方向',
      lGapTip: 'L形餘料大板缺口擺放位置自動調整在定位氣缸對角方向，高光餘料大板除外，同時與xy軸互換功能不兼容',
      cylinderDir: '定位氣缸方向',
      onlyLong: '只修長邊',
      backCutOrder: '反面修邊順序',
      backFirst: '反面最開始修邊',
      backSecond: '反面孔槽加工後修邊',
      frontReCut: '正面再修邊',
      frontReCutTip: '讓定位氣缸邊更光滑，防止有痕跡',
      useNewCut: '啟用新版修邊規則',
      newCutTip: '在雙面加工大板的正面會多修一個修邊尺寸時使用此功能',
      fixedTip: '注意：保留位數為0或1可能會存在排版重疊',
      cuttingSlow: '下料板件表面緩衝',
      holeSlow: '打孔板件表面緩衝',
      slotSlow: '拉槽/銑孔/銑槽板件表面緩衝',
      slowCode: '緩衝指令使用',
      code: '指令',
      bufferOffset: '板件表面緩衝高度偏移',
      zkRotatePoint: '旋轉基準點',
      zkRotateDir: '旋轉角度遞增方向',
      restSizeLimit: '餘料剩餘尺寸小於',
      useSaw: '使用鋸片',
      unGenSawPath: '不生成縱向鋸片切割路徑',
      suitMachine: '適用於全鋁焊接板加工',
      plankBack: '大板後側',
      plankLeft: '大板左側',
      plankRight: '大板右側',
      plankFront: '大板前側',
      frontSide: '前側',
      backSide: '後側',
      rightSide: '右側',
      leftSide: '左側',
      singleMachineLimit: '單面加工板正面生成修邊路徑且先修邊',
      singleMachineLimitTip: '一體機、鋸片切割不生效該功能',
      setBatchPositionWaring: '提示：如果需要取消快速修改下刀點模式，請取消勾選右側修改下刀點按鈕',
      setBatchPosition: '批量修改下刀點',
      setBatchPositionAs: '修改下刀方向為:',
      activeBatchPosition: '已經選擇{activePartCount}塊小板',
      specialFrontSide: '孔槽分流中設置的特殊孔槽優先排在大板正面',
      rollCountTip: '啟用孔槽分流後按照實際在雕刻機加工的反面孔槽計算翻板次數',
      specialFrontSideTip: '當前生產線因開啟【孔槽分流中設置的特殊孔槽優先排在大板正面】或【啟用孔槽分流後按照實際在雕刻機加工的反面孔槽計算翻版次數】功能，不支持切換生產線',
      doubleTrim: '雙面板修邊',
      trim: '修邊',
      trimTwoSide: '修兩邊',
      trimFourSide: '修四邊',
      rightInmShow: '如右圖所示',
      currentTrimDir: '為當前選中修邊方向',
      cylinderTip: '為定位氣缸',
      onlyShort: '只修短邊',
      singleTrim: '單面板生成修邊路徑',
      hierarchyCutTwice: '拉槽銑槽分層切割',
      knifeDia: '刀徑小於等於',
      slotDeep: '且槽深度大於等於',
      cutTwiceSlot: '時，分層切割槽',
      twiceSlotDeep: '第二層切割深度為',
      cutTwiceCondition: '切割條件',
      zkPointCustomizeTip: '開啟xy軸互換會導致加工方向和基準點相反',
      zkPointCustomizeTip1: '開啟xy軸互換的設備不生效該功能',
      isCustom: '開啟自定義',
      useCutCon: '使用鋸切條件',
      singleSetPlankSizeSpeed: '單獨設置小板尺寸範圍加工速度',
      singleSetPlankSizeSpeedTip: '（1.當滿足下方設置尺寸的小板會按照設置的加工速度進行加工 2.當小板同時滿足多條規則時生效速度最小規則 3.該功能不對鋸片切割生效）',
      addSpeedRules: '添加規則',
      speedRules: '規則',
      shortSideSize: '短邊尺寸',
      lessThanEqual: '小於等於',
      and: '且',
      longSideSize: '長邊尺寸',
      processingSpeed: '加工速度',
      trimLenCompensation: '修邊長度補償：',
      trimGenerateAPath: '修邊值為0不生成路徑：',
      cuttingMethod: '裁切方式',
      horizontalCutting: '橫向裁切',
      verticalCutting: '豎向裁切',
      openKnifeDistance: '減速距離'
      },
    labelingSettings: {
      title: '貼標設置',
      output: '輸出自動貼標文件',
      specification: '貼標文件格式',
      codeFrontGenerate: '自動上料代碼在貼標代碼前面生成',
      templateOffline: '所用模板已下線！',
      templateNotSupport: '該模板不支持，請重新選擇！',
      rollLabelling: '翻面貼標設置',
      flipSetting: {
        title: '翻面設置',
        engravingFlipProcess: '雕刻機翻面加工貼標模式',
        flipTip: '雕刻機需要翻面加工時啟用此功能'
        },
      rotateSetting: {
        title: '標籤旋轉設置',
        rotateTip: '根據需求開啟旋轉條件，如果同時開啟，優先生效選擇設定值',
        horizontal: '板材橫邊',
        vertical: '板材豎邊',
        either: '板材橫或豎邊'
        },
      countertopSetting: {
        title: '台面設置',
        startPoint: '工位起始點',
        upLeft: '左上角',
        upRight: '右上角',
        downLeft: '左下角',
        downRight: '右下角',
        baseExchange: '坐標基準對調',
        exchangeX: 'x軸對調',
        exchangeY: 'y軸對調'
        },
      offset: '貼標坐標偏移',
      offsetTip: '一般貼標坐標是在小板中心，部分設備需要調整',
      label_rotate_offset: '標籤旋轉後坐標偏移',
      label_rotate_offset_tip: '針對標籤旋轉前後偏移位置相差較大時，需要調整',
      label_rotate_offset_err_tip: '開啟標籤旋轉後坐標偏移後，X和Y軸坐標偏移量必填',
      imgSetting: {
        title: '貼標圖片設置',
        suffix: '貼標圖片後綴：',
        code: '圖片編碼方式：',
        codeTip: 'png、jpeg會同步修改排版圖編碼格式，且內嵌雲排版暫不支持此功能',
        imgRatio: '貼標圖片分辨率:',
        slowDown: '會降低導出標籤圖片的效率',
        color: '真彩',
        bit: '黑白',
        resolution: '貼標圖片分辨率',
        resolutionPlaceholder: '分辨率',
        labelPool: '數據標籤池',
        showKey: '顯示字段',
        dragTip: '可拖拽標籤池內標籤',
        labelImgName: '貼標圖片名',
        labelImgNameErrTip: '標籤圖片名不能為空',
        labelTip1: '自定義時【板件條碼】或【標籤序號】必須使用其中一項，否則會出現圖片覆蓋的問題',
        labelTip3: '【標籤序號】為開料清單小板從上到下的序列號，排版頁添加的小板無此數據',
        labelTip2: '3、貼標機系統模板不生效此功能',
        delimiter: '分隔符',
        inputTip: '不支持輸入 / : ? < > | . ” * 等字符',
        numStart: '貼標序號起始數值',
        example: '自定義貼標圖片名(示例)',
        stockNumOffset: '大板序號補償位數到',
        divideFolders: '標籤圖片根據大板分為不同文件夾',
        foldersTip1: '注：1、此功能不支持與【開料機文件合併】功能一起使用',
        foldersTip2: '2、此功能暫未對內嵌雲排版生效',
        stickIntoFolders: '貼標文件插入到對應大板的貼標圖片文件夾中',
        stickTip1: '注意: 1、此功能需要和"下載NC順帶導出標籤"功能配合使用；',
        stickTip2: '2、使用的貼標模板中文件生成規則需要選擇"生成單個文件"此功能才生效；',
        stickTip3: '3、此功能暫未對內嵌雲排版生效'
        },
      pdfSetting: {
        title: '貼標PDF設置',
        pdfLabelName: 'PDF文件名',
        example: '自定義PDF文件名（示例）',
        address: '項目地址',
        orderNo: '訂單號',
        firstFolder: '一級文件夾',
        customerName: '客戶名稱'
        },
      paibanImgSetting: {
        title: '排版圖設置',
        tip: '開啟了匯出自定義排版圖，下方固定範本不可匯出，如需匯出請在排版頁更多設定裡面關閉匯出自定義排版圖',
        reparation: '排版圖序號自動補償到',
        figure: '位',
        inputTip: '請輸入1-99的數字',
        paibanImg: {
          export: '導出排版圖',
          prefix: '排版圖名前綴',
          size: '排版圖尺寸',
          format: '排版圖格式',
          directional: '排版圖方向',
          vertical: '豎向',
          horizontal: '橫向'
          }
        },
      autolabel: '自動貼標順序設置',
      customTemp: '僅針對自定義模板生效',
      cuttingLabelOder: '按照開料順序貼標',
      labelToUp: '按照排版結果從下往上貼標',
      labelToDown: '按照排版結果從上往下貼標',
      labelDodge: '貼標自動避讓',
      nolabelForsurplus: '餘料大板不生成貼標文件',
      settingValue: '選擇設定值',
      enabelTip: '開啟後，當小板滿足下列設定值，則標籤旋轉',
      fixedHori: '選擇標籤橫邊與小板固定邊平行',
      fixedHoriTip: '僅對無紋理小板生效，開啟後，貼標時，標籤會旋轉到標籤橫邊和小板固定邊平行',
      tagHori: '標籤橫邊',
      effectiveTarget: '生效對象',
      allPlank: '所有小板',
      notcarePlank: '僅無紋理小板'
      },
    drillSettings: {
      title: '排鑽設置',
      enable: '啟用排鑽包',
      toolTable: {
        use: '啟用',
        number2: '工位2排鑽編號',
        number: '排鑽編號',
        diameter: '鑽頭直徑',
        xOffset: 'X偏移',
        yOffset: 'Y偏移',
        moveZF: 'Z軸快速移動速度',
        feedRate: 'Z軸加工速度',
        moveF: 'XY軸快速移動速度',
        benchmarkDrill: '基準鑽',
        addKnife: '添加刀具',
        deleteKnife: '刪除刀具'
        },
      prefix: '排鑽前綴',
      suffix: '排鑽後綴',
      startCode: '排鑽啟動代碼',
      endCode: '排鑽結束代碼',
      combineKnife: '排鑽組合下刀',
      combineTable: {
        prefix: '排鑽編號前綴',
        suffix: '排鑽編號後綴',
        mainHole: '主孔',
        extraHole: '從孔',
        notes: '組合註釋',
        firstUseNotes: '首次啟用註釋',
        addExtraHole: '添加從孔',
        deleteExtraHole: '刪除從孔',
        example: '樣例'
        },
      tagPool: {
        drillRowNumber: '排鑽編號'
        },
      processSetting: {
        title: '加工設定',
        mode: '排鑽加工模式',
        processTip: '選用此方式後就不生效排鑽組合下刀功能',
        recentHole: '就近打孔（快速換刀）',
        groupHole: '按類打孔（完成一類孔再換刀）',
        drill_benchmark: '組合下刀基準',
        drill_benchmark_Tip: '（注意：選用此方式後就不生效排鑽組合下刀功能）',
        mainHole: '以主孔',
        secondaryHole: '以從孔（尾孔）'
        },
      changeBenchDrillTip: '請輸入排鑽編號再進行此選擇'
      },
    NCExportSettings: {
      jumpSkipTip2: '根據大板顏色，厚度，材質歸為不同文件夾（貼標文件一起），同尺寸大板下料文件放在同一個文件夾',
      title: 'NC導出設置',
      tab1: '開料機文件名設置',
      tab2: '開料機文件名合併',
      tab3: '開料機文件中註釋',
      tab4: '開料機文件中類型',
      tab5: '開料機文件夾',
      tab6: '加工指令設置',
      tab7: '文件格式設置',
      fileNameSettings: {
        twoStationAutoSort: '雙工位自動排序',
        reparation: '大板序號位數補償到',
        figure: '位',
        labelerBegin: '標籤機開頭',
        machineCenter: '加工中心開頭',
        front: '正面:',
        back: '反面:',
        customizeName: '自定義文件名(格式)：',
        example: '自定義文件名(示例)：',
        emptyTip: '正、反面文件標識不能同時為空',
        labelPool: '數據標籤池',
        dragTip: '可拖拽或點擊複製標籤池內標籤到輸入框內'
        },
      fileMerge: {
        engravingMerge: '開料機文件合併',
        zfMerge: '正反面合併',
        singleMerge: '單工位合併',
        doubleMerge: '雙工位合併',
        fEndCode: '反面結束代碼',
        zBeginCode: '正面開始代碼',
        displayfbInfo: '文件名顯示正反面信息',
        fBeginCode: '反面開始代碼',
        zEndCode: '正面結束代碼'
        },
      marginalNotes: {
        addPlankInfo: '開料文件開頭加入當前大板件信息：',
        plankInfo: '大板信息：',
        addStationCodeFirst: '開料文件開頭加入工位代碼：',
        addStationCodeSecond: '開料文件換刀前加入工位代碼：'
        },
      fileType: {
        zAddtion: 'Z坐標補充：',
        addSemicolon: '每行NC末尾加分號：',
        semicolonTip: '勾選後牛角拉手的加工文件也會生效',
        fileName: '文件名',
        defaultName: '默認文件名',
        dedicatedName: '星輝設備專用文件名',
        xhNotes: '星輝E2-9註釋',
        format: '輸出雕刻機文件格式',
        example: '文件樣例: NC文件',
        stillGenerate: '反面不加工時仍然生成含有反面結束代碼的反面NC文件',
        generateTip: '該功能不支持與文件合併功能一起使用',
        fileNameErrTip: '文件名不能包含下列任何字符: / : * ? "'
        },
      categorize: '根據大板顏色、材質、厚度歸為不同文件夾(貼標文件一起)：',
      simplifyG: '加工G指令簡寫',
      ZToW: '代碼從Z軸換為W軸',
      knives: '排鑽刀具',
      lineBreakSetting: '換行符格式設置',
      codeFormatSetting: '文件編碼格式設置',
      utf8bom: '帶bom的UTF-8',
      oneCodeSetting: '板件條碼設置',
      simplifyOneCode: '生成簡易格式標籤條碼',
      codeLocation: '代碼位置設置',
      generateLocation: '工位結束代碼在反面結束代碼前面生成',
      emergencySetting: '應急設置',
      show: '顯示應急設置',
      emergencyCode: '應急碼',
      params: '參數',
      emergencyTip: '可在售後人員配合下臨時實現一些小眾功能',
      holeSetting: '打孔文件設置',
      holeFileCategorize: '打孔文件按不同訂單分文件夾單獨放置',
      holeTip: '對內嵌櫃櫃客戶端的雲排版不生效',
      specialCodeErr: '不支持輸入特殊字符!',
      copySuccess: '複製成功!',
      copyErr: '複製失敗, 請嘗試拖拽標籤!',
      lengthLimit: '只支持輸入15位!',
      plankInfo: '板件信息',
      otherInfo: '其他信息',
      uniqueBarCode: '板件條碼唯一',
      uniqueBarCodeForPack: '板件條碼唯一(打包專用)',
      machineOrder: '下料文件名生成加工序號',
      folderSetting: '同尺寸大板下料文件放在同一個文件夾',
      labelImageINCFolder: '貼標圖片跟隨貼標文件放在NC文件夾裡',
      custom: '定制',
      folderSettingTip: '注： 內嵌排版暫不支持此功能',
      settingMoveTip: '原"{func}"功能已遷移到"{module}"頁面中！',
      fileManagerFunction: '打孔文件按不同訂單文件分文件夾單獨放置',
      gotoSetting: '前往設置',
      singleFileTitle: '單獨文件加工設置',
      slectSingleProcess: '選擇單獨輸出工藝',
      slectSingleProcessTip: '存在付費二次加工工藝，請刪除後重新保存',
      setSingleRegularSize: '設置單獨輸出常規孔槽尺寸',
      holeRange: '孔生效範圍',
      slotRange: '槽生效範圍',
      holeRangeTip: '孔生效範圍不可為空，請填寫！',
      slotRangeTip: '槽生效範圍不可留空，請填寫！',
      yhzc: '圓弧折彎部分直槽',
      xbgy: '斜邊海棠角和斜邊拉手',
      nbyx: '內部異形',
      secondaryProcessingMerge: '二次加工文件合併',
      secondaryProcessingMergeName: '合併文件名',
      secondaryProcessingMergeTip: '開啟後，當導出的板件存在多個二次加工工藝，則會合併到同一個加工文件',
      singleFileSetting: '輸出單獨文件加工斜邊款海棠角和斜邊拉手',
      straightArcSlot: '輸出單獨文件加工圓弧折彎部分的直槽'
      },
    aioMachineSetting: {
      openFunction: '對接需開啟以下功能',
      openCarving: '開啟雕刻機',
      xyReverseFunction: 'XY軸互換功能',
      carvingStartSet: '雕刻機工位起始點設置為',
      rightTop: '右上角',
      carvingEdgeSet: '雕刻機正面再修邊值調整為',
      finalEdgeSame: '與總修邊值相同',
      beginCode: '程序開始代碼',
      endCode: '程序結束代碼',
      drillHole: '打孔',
      pullTrough: '拉槽',
      showDataTemp: '顯示數據樣例',
      dataTemp: '數據樣例',
      title: '一體機設置',
      outputFile: '輸出一體機加工文件',
      outputFileTips: '部分品牌的一體機，與XY互換、文件合併、不打穿異形孔不兼容，請謹慎使用',
      fileType: '文件格式',
      select: '請選擇',
      diameter: '修邊刀具直徑',
      jidongTip: '使用極東一體機請將雕刻機工位起始點設置為右上角，並開啟A功能',
      skill: '功能',
      clampHandLength: '夾手長度(L)',
      clampHandWidth: '夾手寬度（W）',
      clampHandMargin1: '夾手1距邊(H1)',
      clampHandMargin2: '夾手2距邊(H2)',
      duchClampHand: '孔槽避讓夾手位置',
      clampHandDirection: '夾手方向',
      left: '左側',
      right: '右側',
      top: '上側',
      bottom: '下側'
      },
    oneDragTwo: {
      title: '一拖二雕刻機',
      outputMachineFile: '輸出一拖二雕刻機加工文件',
      outputMachineFileTips: '啟用一拖二雕刻機後與開料機文件合併功能不兼容，請謹慎使用',
      fileType: '文件格式',
      select: '請選擇',
      machineStart: '工位起始點',
      positionClose: '關閉時將跟隨切割參數中工位起始點設置',
      engravingPlus: '速雕雕刻機'
      },
    sawEngraving: {
      title: '鋸切雕刻機',
      preLayNav: '鋸切雕刻機設置',
      preLayKnifeInput: '鋸片橫切刀直徑',
      enableSaw: '啟用鋸切雕刻機',
      sawAioTip: '暫無輸出焊接板一體機權限，請聯繫銷售開通',
      cutSet: '焊接板切割設置',
      weldingPlank: '焊接板',
      doorFrame: '門套',
      doorFrameTip1: '下料刀半徑必須≤鋸片厚度',
      doorFrameTip2: '2.不支持异形板件排版3.排版間隙自動為0',
      sawUsing: '鋸片用途',
      trim: '修邊',
      cutBlank: '切割下料',
      backTrimOblique: '反面修邊',
      holeSlotOblique: '拉槽/铣孔/铣槽',
      plankThicknessUnit: '表中板厚單位為',
      sawUseCond: '鋸片使用條件',
      exportPartData: '輸出小板數據文件',
      sawAioTip2: '適用於免翻版數據切一體機',
      hasUsing: '有可用路徑便使用',
      onlyUse: '時才使用',
      cutMethod: '切割方式',
      oneKnifePull: '一刀拉穿大板',
      onlyOneKnifePull: '時才直接一刀拉穿',
      enableSawThick: '啟用鋸片厚度排版',
      edgedDir: '已封好不再切的大板邊',
      sameWidthPart: '每張大板上只排相同寬度小板',
      emptyPath: '切割時不生成空走路徑',
      sawUsePlank: '焊接板材使用鋸片加工',
      paibanGap: '焊接板排版間隙',
      minSurplusWidthDiff: '最小餘料匹配寬度差',
      minSurplusWidthDiffTip: '僅當小板與餘料的寬度差小於此值時，小板才會排在餘料上',
      sawReplaceEnable: '開料直刀切割路徑主體改用鋸片',
      minSawLength: '最短改用鋸片的距離',
      keepDistance: '相鄰更寬板間保留的開料直刀切割距離',
      keepDistanceTip: '注意：要留夠充足的距離，不然鋸片會切到旁邊板件',
      sortByLength: '按板件長度依次排版',
      sortByLengthTip: '切割方向是從下到上依次切割，排板是先按寬度再按長度排',
      plankAtTop: '小板在上',
      plankAtBottom: '小板在下',
      useSawTipOne: '啟用後僅櫃體中焊接板屬性的小板才會使用鋸片加工，非焊接板將使用直刀切割',
      useSawTipTwo: '啟用後"自定義大板排版順序"將不會使用標準大板進行排版，如需混合排版請在特殊大板中添加焊接板和蜂窩板原片數據',
      useSaiTipThree: '啟用該功能後，排版方案必須使用鋸切排版',
      surplusStoreAndLabeling: '切斷後的剩餘材料可以入庫和打印標籤',
      surplusMinLength: '剩餘材料的最小可用長度',
      surplusMinSize: '剩餘材料的最小可用尺寸',
      crossCutOnlyMinSurplusSize: '只有剩餘材料達到最小可用尺寸時才生成橫切剩餘材料路徑',
      surplusStoreAndLabelingTip: '1、在每張大板上，剩餘材料將生成在上方或下方，剩餘材料可以入庫和打印標籤',
      surplusStoreAndLabelingTip2: '2、剩餘材料自動裁剪功能對焊接板不生效）',
      surplusStoreAndLabelingTip3: '（啟用後',
      backCutSurplus: '從反面截取剩餘材料',
      cutSurplusTip: '啟用後請將反面修邊順序設置為"反面孔槽加工後修邊',
      top: '上邊',
      bottom: '下邊',
      left: '左邊',
      right: '右邊',
      dockTip: '對接焊接板加工需要矩形板四邊封邊和總修邊一樣，且手動操作成單列排版',
      sawToLayoutTip: '啟用該功能後，排版時小板間只會預留等於鋸片厚度的切割縫',
      sawToLayoutTip2: '鋸切排版暫不支持指定下料刀',
      tempPaiabanTip: '啟用鋸片切割後不支持直接在排版添加異形板件，如需添加請前往開料清單添加並排版！',
      generateCutSurplusPath: '生成先切斷餘料的橫切路徑',
      curSurplusPathTip: '啟用後請將反面修邊順序設置為"反面孔槽加工後修邊"'
      },
    robotArmDocking: {
      autoLine: '自動線對接',
      autoLineTip: '您沒有自動線使用權限或者能開啟的自動線數量不足',
      title: '機械臂對接',
      enable: '啟用機械臂對接',
      enableTip: '開啟後，輸出生產文件時，會輸出機械臂對接文件'
      },
    laserCuttingMachine: {
      title: '激光切割一體機',
      enable: '啟用激光切割一體機',
      backSafeHeight: '反面空閒時Z高度(H)',
      laserDistance: '正/反面激光刀切割時與板材表面的距離',
      coordinateAxis: '坐標軸',
      xAxis: 'X',
      yAxis: 'Y',
      zAxis: 'Z',
      cuttingSettings: '切割設置',
      backKnifeStore: '反面刀庫',
      noSupportOriginalMaterialKnife: '暫不支持 "原片下料刀選擇" 功能',
      laserKnifeTip: '開料：用於加工內部未打穿異形',
      laserKnifeTip2: '激光刀：加工打穿的孔槽、內部異形、外輪廓下料',
      laserKnifeTip3: '注意：反面Z軸默認使用與台面距離對應的相對座標',
      laserKnifeTip4: '刀具不能少於1個',
      laserKnifeTip5: '不能刪除開料刀',
      laserKnifeTip6: '檢測到沒有刀具勾選開料，請至少勾選一把刀具',
      laserKnifeTip7: '激光刀不可加工內部未切透的異形，已自動取消"開料"項勾選',
      laserKnifeTip8: '刀庫中請勾選"開料"選項的刀具，不然無法加工內部未切透異形',
      laserKnifeTip9: '開料刀庫激光刀徑和激光一體機激光刀徑不一致，請檢查',
      laserKnifeTip10: '開料刀庫下料刀徑和激光一體機下料刀徑不一致，請檢查',
      laserKnifeTip11: '設備對接參數已修改，請重新排版',
      noLaserPermission: '沒有激光一體機使用權限，請聯繫銷售購買激光一體機使用權限後使用',
      laserOpenCode: '激光開啟代碼',
      laserCloseCode: '激光關閉代碼',
      laserToolSettings: '正/反面激光刀設置'
      },
    firstSave: '檢測到用戶是第一次使用雲排版，保存設置後請注意文件中的修邊方向是否合理，避免不必要的損失',
    knives: {
      xOffset1: 'X座標偏移',
      yOffset1: 'Y座標偏移',
      zOffset1: 'Z座標偏移',
      insert: '插入行',
      delete: '刪除行',
      tip: '（註：完成刀庫信息的修改或設置的調整後，在櫃櫃排版生產的用戶需要重啓櫃櫃客戶端，以應用最新的變更！）',
      number: '編號',
      name: '名稱',
      diameter: '刀直徑Φ',
      sawDiameter: '鋸片厚度Φ',
      cutting: '開料',
      use: '用途',
      moveZF: 'Z軸快速移動速度',
      axis_offset: '軸偏移',
      arc_radius: '圓弧半徑',
      cutZF: 'Z軸加工速度',
      moveF: 'XY軸快速移動速度',
      cutF: 'XY軸加工速度',
      startCode: '換刀開始代碼',
      stopCode: '換刀結束代碼',
      startCode2: '工位2換刀開始代碼',
      stopCode2: '工位2換刀結束代碼',
      knifeLength: '刀具長度',
      maximum_single_depth: '單次最大加工深度',
      specialShapeKnifeTip: '僅對內部異形生效',
      preStartCode: '預啓動代碼',
      punchHoles: '打孔',
      pullSlots: '拉槽',
      millHoles: '銑孔',
      millSlots: '銑槽',
      sawBlade: '鋸片',
      doubleSaw: '啓用雙工位不同換刀開始代碼',
      singleStation: '單工位',
      doubleStation: '雙工位',
      sawBladeTip: '該功能不對一拖二雕刻機和一體機生效',
      serialNum: '編號',
      sawWidth: '刀寬度',
      sawType: '鋸片類型',
      cutDirection: '切割方向',
      moveSpeed: '空走速度',
      cutSpeed: '加工速度',
      endCode: '換刀結束代碼',
      sawDownCode: '下刀代碼',
      sawUpCode: '收刀代碼',
      abscissa: '橫座標前綴',
      ordinate: '縱座標前綴',
      sawHor: '橫切鋸片',
      sawVer: '縱切鋸片',
      towardsZero: '向0點座標切割',
      awayFromZero: '遠離0點座標切割',
      diameterDesc: '刀直徑Φ',
      xOffset: '橫向座標偏移',
      yOffset: '縱向座標偏移',
      zOffset: '升降座標偏移',
      offsetX: '偏移X',
      offsetY: '偏移Y',
      offsetZ: '偏移Z',
      offsetNo: '偏移號',
      knifeWidth: '刀寬',
      drill: '下刀',
      cut: '加工',
      speed: '轉速',
      type: '類型',
      millHoleSlot: '銑孔/槽',
      rapidFeedSpeed: '快速進給速度',
      typeOption1: '鑽頭',
      typeOption2: '銑刀',
      typeOption3: '造型刀',
      typeTip: '設置刀具類型後孔槽會匹配對應類型的刀具進行加工'
      },
    other: {
      title: '其他',
      tip: '（注意：單工位設備需要將工位1和工位2都填上相同的自動上料代碼）'
      }
    },
  sideHoleMachine: {
    moreSetting: '更多設定',
    sideStartCode: '正面加工生成換面代碼',
    useArcCode: '圓弧插補指令切割弧形',
    coordSwitch: '座標基準對調',
    updownCoordSwitch: '升降座標基準對調',
    xCoordSwitch: '橫向座標基準對調',
    yCoordSwitch: '縱向座標基準對調',
    knifes: {
      number: '編號',
      diameter: '刀寬',
      type: '類型',
      moveSpeed: '快速進給速度',
      doSpeed: '加工速度',
      startCode: '換刀開始代碼',
      endCode: '換刀結束代碼'
      },
    ymSetting: '易木連接設置',
    flanking: '側面加工',
    frontProcess: '正面加工',
    oldSetting: '舊版設置',
    equipParamsSetting: '設備參數設置',
    holeSetting: '打孔設置',
    raminoSetting: '拉米諾連接設置',
    mortiseTenonSetting: '榫卯連接設置',
    straight: '直款',
    eccentric: '偏心款',
    pbSize: '上下破板尺寸',
    slotOverlapRate: '銑槽重疊率',
    breakingBoardDirection: '上下破板方向',
    coordinateValue: '座標值',
    codeFormat: '文件編碼格式',
    suffixSetting: '文件後綴設置',
    insertRow: '插入行',
    deleteRow: '刪除行',
    equipmentParams: {
      equipPauseCode: '設備暫停代碼',
      wiggleCode: '擺動代碼',
      equipStartCode: '設備啟動代碼',
      flipPauseCode: '翻面暫停代碼',
      equipEndCode: '設備結束代碼',
      equipStartCodePlaceholder: '輸入設備啟動代碼',
      retractingCode: '收刀指令代碼',
      retractingCodePlaceholder: '輸入收刀指令代碼',
      flipPauseCodePlaceholder: '輸入翻面暫停代碼',
      equipEndCodeTip: '輸入設備結束代碼',
      sideChangeSetting: '側面換面設置',
      workTip: '默認從左側①開始沿逆時針方向加工',
      frontTurnCode: '上面開始代碼',
      frontTurnEndCode: '上面結束代碼',
      frontTurnCodePlaceholder: '輸入上面開始代碼',
      frontTurnEndCodePlaceholder: '輸入上面結束代碼',
      leftTurnCode: '左面開始代碼',
      leftTurnEndCode: '左面結束代碼',
      leftTurnCodePlaceholder: '輸入左面開始代碼',
      leftTurnEndCodePlaceholder: '輸入左面結束代碼',
      downTurnCode: '下面開始代碼',
      downTurnEndCode: '下面結束代碼',
      downTurnCodePlaceholder: '輸入下面開始代碼',
      downTurnEndCodePlaceholder: '輸入下面結束代碼',
      rightTurnCode: '右面開始代碼',
      rightTurnEndCode: '右面結束代碼',
      rightTurnCodePlaceholder: '輸入右面開始代碼',
      rightTurnEndCodePlaceholder: '輸入右面結束代碼',
      topFlipCode: '翻面代碼 - 上',
      downFlipCode: '翻面代碼 - 下',
      leftFlipCode: '翻面代碼 - 左',
      rightFlipCode: '翻面代碼 - 右',
      cylinderOutCode: '氣缸推出代碼',
      cylinderbackCode: '氣缸收回代碼',
      cylinderbackDirective: '氣缸收回指令',
      moveDirective: '移動指令',
      moveAxisCode: '移動軸',
      pushAxisCode: '氣缸推動軸',
      swingAxisCode: '擺動軸',
      moveCode: '移動代碼',
      punchCode: '加工代碼',
      free: '空走',
      punchPart: '加工部分',
      cutFaceCode: '加工平面代碼',
      horVerCutFace: '橫向縱向平面',
      horCutFace: '橫向升降平面',
      verCutFace: '縱向升降平面',
      specifySmallBoardMaterialNoCut: '指定小板材質不下料',
      specifySmallBoardMaterialNoCutTip: '板件材質中含有對應關鍵詞的板件便只會生成五六面鑽加工的孔槽文件，不會下料',
      addMaterialKeyword: '添加材質關鍵詞',
      keyword: '關鍵詞'
      },
    tagPool: '數據標籤池',
    dragTip: '可拖拽標籤池內標籤',
    knives: '加工刀具：',
    directives: '加工指令：',
    slot: '直槽加工',
    cirWork: '圓弧加工',
    cirInter: '圓弧插補',
    cirOption1: '順時針：G03 逆時針：G02',
    cirOption2: '順時針：G02 逆時針：G03',
    coordinate: {
      xPointSymbol: '橫向座標：',
      yPointSymbol: '縱向座標：',
      zPointSymbol: '升降座標：',
      upright: '正值',
      negative: '負值'
      },
    encodeFormat: {
      format: '文件編碼格式：',
      wrap: '換行符格式設置：',
      formatOption1: 'UTF-8格式',
      formatOption2: 'ANSI格式'
      },
    suffix: '文件後綴設定：',
    enableFP: '啓用正面加工',
    slotSetting: '拉槽設置',
    slotMillSetting: '拉槽/銑孔銑槽設置',
    millSlot: '支持銑孔銑槽',
    millingSlotOverlapRate: '銑槽重疊率',
    millingHoleSlotOverlapRate: '銑孔銑槽重疊率',
    takeUpDirective: '收刀指令',
    workSeparately: '正/反面通槽分兩段加工',
    secondSlotLong: '第二段槽長度',
    enableOld: '啓用舊版側孔機設置',
    default: '默認設置',
    customizable1: '自定義一',
    customizable2: '自定義二',
    customizable3: '自定義三',
    customizable4: '自定義四',
    knifeSetting: '刀具設置',
    soltTip: '(包括銑孔/槽)',
    specialSetting: '特殊設置',
    ramino: '拉米諾',
    sun: '榫卯',
    please: '敬請期待',
    designatedKnives: '指定用刀',
    designated: '指定',
    workOrder: '加工命令',
    other: '其他',
    nameSetting: '後綴名設置',
    repeatErr: '編號重複，請重新設置'
    },
  electronicSaw: {
    importMaterial: '導入原料單',
    formSetting: '電子鋸表單設置',
    fileFormat: '輸出開料清單文件格式：',
    isSmallFile: '導出小板圖片文件：',
    fileGroupRule: '電子鋸文件根據顏色、材質、板厚分不同表格：',
    roomsByCategory: '電子鋸文件根據房間分不同表格：',
    delimiter: '分隔符：',
    fileName: '開料清單文件名：',
    fineNameTip: '開料清單文件名不能為空！',
    fileNamePlaceholder: '自定義開料清單',
    outputFileEncoding: '輸出清單編碼格式：',
    utf8: 'UTF-8帶BOM',
    cellTab: '生成單元格制表符：',
    texture: '紋理表示：',
    special: '異形表示：',
    notSpecial: '不是異形',
    genSimpleLabelBarcode: '生成簡易格式標籤條碼',
    uniqueBarCode: '板件條碼唯一',
    uniqueBarCodeTip: '開啟後生成簡易格式標籤條碼功能不生效',
    roboticArmDocking: '機械臂對接',
    customeForm: '自定義表單',
    tagPool: '數據標籤池',
    tagPoolTips: '可拖拽或點擊複製標籤池內標籤',
    displayHead: '不顯示表頭',
    addTableHead: '添加表頭',
    deleteTableHead: '刪除表頭',
    generateExample: '生成輸出表單樣例',
    importExample: '導入表單樣例',
    importExampleTip: '導入的表單樣例，僅供自定義電子鋸參考',
    importExampleErrTip: '還沒有導入原料單，請導入原料單',
    outputExample: '輸出表單樣例',
    outputExampleTip: '自定義表單的輸出樣例',
    outputExampleErrTip: '還沒有生成輸出表單樣例，請生成輸出表單樣例',
    defaultTableHead: '默認表頭',
    deleteHeadErrTip: '沒有可以刪除的表頭!',
    genNonString: '生成非文本格式數據類型',
    genNonStringTip: '生成的表格數據電子鋸無法識別時可以嘗試啟用',
    revertWidth: '橫紋板件長寬對調'
    },
  lockModal: {
    passwordInput: '請輸入密碼',
    lockPassword: '鎖定密碼',
    lockPasswordInput: '請輸入解鎖密碼',
    passwordInputPlaceholder: '請輸入四位數密碼',
    editPassword: '修改密碼',
    confirmPassword: '確認密碼',
    setLockPwd: '設定解鎖密碼',
    pwdFormatErr: '密碼格式錯誤',
    sendMessageTo: '簡訊驗證碼將發送至',
    captchaPlaceholder: '請輸入驗證碼',
    sendCaptcha: '發送驗證碼',
    sendSeccess: '簡訊發送成功',
    sendFail: '簡訊發送失敗，請稍後重試',
    updateSeccess: '密碼設定成功',
    editSuccess: '密碼修改成功',
    lockSeccess: '解鎖成功',
    lock: '解鎖',
    lockSeccessTip: '鎖定成功',
    inputErrLimit: '當前錯誤次數已達限制，請重新設定解鎖密碼！'
    },
  dock56Drill: {
    equipType: '設備類型',
    equipment: '設備',
    fiveDock: '五面鑽',
    sixDock: '六面鑽',
    fileType: '生成文件類型',
    templateOffline: '所用模板已下線！',
    showExample: '顯示數據樣例',
    conNoticeTip: '對接注意事項：',
    conNoticeTip1: '1、啟用了「XY軸互換」的雕刻機需開啟雕刻機中的「孔槽加工設備自動適配互換」功能',
    conNoticeTip2: '2、要在五六面鑽上顯示或加工板件異形部分需要在模板中配置異形部分的數據',
    conNoticeTip3: '3、首次使用五六面鑽或更換模板後請<span style="color:#f00">進行櫃體試生產</span>，在確認無誤後再進行常規生產',
    conNoticeTip4: '4、試生產時請仔細檢測正反面孔槽的大小、深度、所在面、以及所在位置是否正確，<span style="color:#f00" >避免出現櫃體鏡像</span>的問題',
    example: '數據樣例',
    commonSetting: '通用參數設置',
    throughHoleSetting: '通孔分雙面打通',
    throughSlotSetting: '通槽分雙面打通',
    nonHolesNotFiles: '矩形板沒有孔槽不輸出文件：',
    frontFileIdentifier: '正面文件標識：',
    oppositeFileIdentifier: '反面文件標識：',
    oppositeFileIdentifierTips: '生成方式為：原13位板件編碼+標識字符',
    arcDescription: '圓弧描述方式',
    linePoints: '線段成型描述',
    arcCommand: '圓弧指令描述',
    slotWidthSplit: '寬槽拆解為多條窄槽加工：',
    slotSplitWidth: '拆解後單條槽寬度：',
    mm: '註：拆解對象為普通矩形槽',
    isNotMergeSlot: '相鄰的等寬等深槽拉通處理：',
    slotPunchTip: '此功能僅對使用自定義模板的背板槽和抽屜底板槽生效',
    sizeRange: '相鄰尺寸小於等於',
    enableWorningTip: '此功能與前封邊擺放方向不能同時開啟',
    longDirection: '板件長邊擺放方向',
    horizontal: '橫向',
    vertical: '縱向',
    slotDirection: '五/六面鑽槽或異形放置方向',
    default: '系統默認',
    frontLeft: '前和左',
    frontRight: '前和右',
    backLeft: '後和左',
    backRight: '後和右',
    frontDirection: '前封邊擺放方向',
    enableTip: '註：僅對雲排版生效',
    fixedOn: '固定在：',
    front: '前邊',
    back: '後邊',
    left: '左邊',
    right: '右邊',
    coordinateValue: '座標值保留位數：',
    decimalPlaces: '位',
    slotLengthCompensation: '槽長度補償',
    curveholesLengthCompensation: '內部異形補償',
    slotCompensationEqualZero: '距邊為0的槽邊補償',
    slotCompensationNotEqualZero: '距邊不為0的槽邊補償',
    slotCompensationTip: '加工出現未切乾淨的小圓角或長度不夠時使用此功能',
    curveholesCompensationEqualZero: '距邊為0的直角長度補償',
    curveholesCompensationTip: '建議輸入：銑內部異形刀具的半徑值',
    curveholesCompensationTip2: '在板件輪廓外接矩形邊加工的內部異形出現未切乾淨的小圓角時使用此功能',
    specialParameter: '特殊參數設置',
    output5FDrillSlotKnifeCode: 'XML2銑槽刀具編號',
    output5FDrillShapeKnifeCode: 'XML2銑型刀具編號',
    plankTexture: 'XML2板件紋理',
    offset: 'XML2銑型刀具補償',
    mprConHoleDir: '五/六面鑽MPR文件側面孔Z座標基準面',
    plankTop: '板件上表面',
    plankBottom: '板件下表面',
    codeInfo: 'ban格式文件包含Code信息：',
    bomFile: '輸出bom格式文件：',
    plankHeight: '板件高度描述：',
    plankNum: '板號描述：',
    backZpoint: '反面槽Z座標：',
    plankThick: '板厚',
    slotDeep: '槽深',
    outputMprFile: '文件類型',
    oldMPR: '舊版MPR',
    newMPR: '新版MPR',
    mprFileZside: '五/六面鑽MPR文件側面孔Z座標基準面',
    fileTypeOffline: '當前選擇的五六面鑽文件類型已下線, 請確認!',
    permissionErr: '身份信息已丟失, 請重新從櫃櫃中打開此頁面!',
    banFileSetting: 'ban格式文件設置',
    banFileCodeInfo: 'ban格式文件包含Code信息：',
    huahuaLine: '樺樺自動線',
    huahuaLineTip: '（不兼容標籤放板基準）',
    huahuaPartFlag: {
      longSide: '長邊小於',
      shortSide: '或短邊小於',
      partFlag: '的板件生成小板標識',
      tip: '（標籤上展示需添加「板件標識-小板標記」數據，樺樺自動線文件中會自動添加對應數據）'
      },
    plankPutWay: '板件擺放方式',
    plankPutWayTip: '若當前生產線開啟樺樺自動線則不支持單獨設置板件擺放方式',
    autoHandle: '自動避讓夾手',
    manualHandle: '手動設置避讓',
    fixedFront: '固定前封邊',
    plankNamePlacement: '指定板件名擺放',
    plankNamePlacementTip1: '1、設置後，當板件名稱中包含所設字段時，該板件將按對應設置固定對應邊在設備的指定側',
    plankNamePlacementTip2: '2、此處設置的優先級大於上方的板件擺放方式設置',
    plankNamePlacementTip3: '3、該功能僅對雲排版生效，若當前生產線開啟樺樺自動線則不支持單獨設置板件擺放方式',
    addRow: '添加行',
    plankNameTip: '請輸入板件名',
    plankSide: '板件邊',
    deviceSide: '固定在設備',
    weldingPlatePlacementEnable: '焊接板原邊固定靠夾手',
    onlyBluen: '僅對雲排版生效',
    fixedEdge: '固定前封邊',
    fixedEdgeRule: '規則說明：判斷板件擺放情況',
    fixedEdgeRuleItem1: '長邊靠夾手',
    fixedEdgeRuleItem2: '封邊靠夾手',
    fixedEdgeRuleItem3: '孔槽避讓',
    fixedEdgeRuleItem4: '優先順序',
    satisfiedCondition: '滿足條件',
    handDirection: '夾手所在方向',
    handleMachineTip: '通過旋轉的方式讓孔槽和異形自動避讓夾手所在側，便於板件加工',
    handleWidth: '夾手寬度',
    handleLength: '夾手長度',
    handleMaxWidth: '設備可加工的最大寬度',
    usefulRange: '生效範圍',
    plankLongSide: '板件長邊',
    usefulRangeTip: '當開啟板件長邊擺放且板子長邊在該生效範圍內會優先判斷槽和異形放置位置',
    moveTip: '正反面文件標識功能已遷移至',
    millingOuter: '銑外異形',
    millingInner: '銑內異形',
    drilling: '加工孔',
    slotting: '加工槽',
    knivesTip1: '1、設置銑異形刀後切割路徑將補償其刀半徑',
    knivesTip2: '2、異形切割暫不支持xy軸互換的雕刻機',
    internalCutting: '內部異形切割下刀和收刀均在板件內側',
    externalCutting: '外部異形切割下刀和收刀均在板件外側',
    externalCuttingDirection: '外部異形切割時，包含異形的整條邊緣將同步切割',
    allExternalCutting: '所有外異形',
    onlyArcExternalCutting: '僅外圓弧異形'
    },
  doorWallCabinet: {
    tempErrTip: '檢測到您未添加門牆櫃一體機所用模板，從而無法導出門牆櫃一體機加工文件，注意：添加完成後需要重新排版',
    title: '門牆櫃一體機',
    guifang: '歸方',
    processingTechnology: '加工工藝',
    longPlateSecondarySquaring: '長板二次歸方',
    slotOnDoorPlate: '門板上的槽',
    setting: '門牆櫃一體機設置'
    },
  PTP: {
    title: 'PTP',
    outputFileFormat: '輸出文件格式',
    outputDefaultFileFormat: '輸出默認格式文件',
    outputMPRFormat: '輸出MPR格式文件',
    fileFormatSettings: '文件格式設置',
    wrapSettings: '換行符格式設置：',
    enCodeSettings: '文件編碼格式設置：',
    utf8bom: '帶bom的UTF-8',
    partCoordinate: '小板座標',
    xPointSymbol: '橫向座標：',
    yPointSymbol: '縱向座標：',
    zPointSymbol: '升降座標：',
    upRight: '正值',
    negative: '負值',
    plankMirroring: '板件鏡像',
    plankMirrorSetting: '板件鏡像設置：',
    xAxis: 'X軸鏡像',
    yAxis: 'Y軸鏡像',
    mirrorTip: '（板件鏡像時使用此功能）',
    knifeTable: {
      type: '類型',
      diameter: '直徑Φ',
      offsetX: '偏移X',
      offsetY: '偏移Y',
      offsetZ: '偏移Z',
      offsetNo: '偏移號',
      drillVelocity: '下刀[F]mm/min',
      cutVelocity: '加工[F]mm/min',
      rotationSeep: '轉速[S]r/min',
      insertRow: '插入行',
      deleteRow: '刪除行'
      },
    labelPool: '數據標籤池',
    dragTip: '可拖拽或點擊複製標籤池內標籤到輸入框內',
    procedure: '程序',
    beginCode: '程序開始代碼：',
    endCode: '程序結束代碼：',
    zzdKnifeBeginCode: '主軸刀換刀開始代碼：',
    spindleCutter: '主軸刀',
    zzdKnifeEndCode: '主軸刀換刀結束代碼：',
    verticalDrill: '垂直鑽',
    czzBeginCode: '垂直鑽啟動代碼：',
    czzEndCode: '垂直鑽結束代碼：',
    czzKnifeBeginCode: '垂直鑽換刀開始代碼：',
    czzKnifeEndCode: '垂直鑽換刀結束代碼：',
    sidetrack: '側鑽',
    czBeginCode: '側鑽啟動代碼：',
    czEndCode: '側鑽結束代碼：',
    czKnifeBeginCode: '側鑽換刀開始代碼：',
    czKnifeEndCode: '側鑽換刀結束代碼：',
    pauseCode: '暫停代碼：',
    zSafeHeight: '安全距離',
    spindleKnife: '主軸刀和垂直鑽Z軸安全高度',
    sideDrillZ: '側鑽Z軸安全高度',
    sideDrillXY: '側鑽X/Y軸安全距離',
    auxiliaryFunction: '輔助功能',
    xhDedicatedInfo: '生成星輝設備專用信息',
    xhCheckBox: '數據：',
    outputSettings: '輸出設置：',
    partExegesis: '文件中生成小板尺寸註釋',
    knifeNo: '刀具編號',
    specailKnifeNo: '加工異形刀具編號：',
    slotKnifeNo: '開槽刀具編號：',
    fileNamePlaceholder: '自定義開料清單',
    slotDrill: '拉直器刀'
    },
  glassEquip: {
    title: '玻璃切割機',
    fileType: '加工文件類型：',
    sizeReparation: '板材尺寸補償：',
    cutPreSpace: '板件切割預留間距：',
    divideIntoFolders: '根據玻璃顏色、材質、厚度歸為不同文件夾：'
    },
  translate: {
    search: '請輸入中文或者官方翻譯尋找詞條',
    en: '英文',
    es: '西班牙語',
    ar: '阿拉伯語',
    kz: '哈薩克語',
    vi: '越南語',
    th: '泰語',
    id: '印尼語',
    ug: '維吾爾語',
    customTranslate: '點擊可添加自定義翻譯',
    customText: '自定義翻譯',
    text: '中文',
    targetLang: '官方翻譯',
    zh_hant: '中文繁體'
    },
  preLayoutSetting: {
    title: '預排版設置',
    titleTip: '可以先預設排版參數，先排版，後選生產線',
    settingTip: '在生產線內設置的參數需要和以下預排版參數一致才能輸出生產文件，僅對開料機生效',
    emptyKnife: '刀具未填寫',
    noModify: '設置沒有修改，無需保存',
    reSet: '復原',
    gayPosition: '灰色方塊可切換餘料擺放位置',
    surplusPosition: '為當前餘料擺放位置',
    click: '點擊',
    grayStart: '灰色方塊可切換工位起始點',
    currentStart: '為當前工位起始點',
    holeSlotSetting: '拉直器、孔槽加工設置',
    knifeDiameter: '開料刀直徑',
    currentVersion: '當前版本',
    on: '開啟',
    off: '關閉',
    firstShort: '首次切割-短邊放量',
    firstLong: '首次切割-長邊放量',
    cuttingSplitLong: '長板分兩次切割-長邊超過',
    cuttingSplitShort: '長板分兩次切割-短邊超過',
    plankThick: '非門板厚度 ≥ ',
    singleDoorThick: '門板厚度 ≥ ',
    normalPlank: '常規板',
    confilictTip: '存在設置衝突項：{confilictTotal}個',
    selectLine: '選擇生產線',
    selectLinePlaceholder: '請選擇生產線',
    lineConfilictTip: '選擇生產線和{line}存在衝突',
    preWay: '預排版方案',
    paibanErrTip: '長板加工的【長、短邊放量】有變化時，可能導致排版失敗',
    paibanTip: '本次排版存在大板材質指定下料刀，需要重新排版',
    reLayout: '以當前生產線重新排版',
    fetchErr: '獲取預排版設置失敗',
    resetSuccess: '還原成功',
    resetConfirm: '確定復原到歷史版本？',
    prolineName: '生產線名稱',
    layoutGap: '排版間隙',
    generalThickness: '二次切割對象-常規板厚度',
    cutGeneralPlank: '二次切割對象-常規板',
    cutSingleDoor: '二次切割對象-門板',
    secondary_cutting_board_list: '指定板件名切割板件名清單',
    changeProline: '切換生產線',
    backTip: '請返回全局排版選擇生產線',
    preLayout: '按預排版方案排版',
    preWayEmpty: '(空)預排版方案',
    specialConfilictTip: '圓弧銑底工藝影響了排版結果，需要重新排版'
    },
  lunbo: {
    tips: '操作小技巧',
    introduction: '功能介紹',
    qtDownloadText: '溫馨提示：如果出現下載文件不全的情況，請前往雲排版網頁端進行下載！'
    },
  sendModal: {
    paibanImgType: '排版圖檔案類型'
    },
  authenticationModal: {
    title: '掃碼授權驗證',
    tip: '授權成功前請勿關閉彈框！',
    countdownTip: '{countdown} 後過期',
    refreshTip: '刷新二維碼',
    qrcodeTip: '請用微信掃碼完成操作',
    qrcodeTip2: '如果掃碼保存失敗則需要在櫃櫃通用設置-用戶授權設置中授權您修改系統的權限。',
    waiting: '等待掃碼',
    scanning: '已掃碼，等待確認',
    success: '驗證成功',
    error: '驗證失敗',
    expired: '二維碼已過期',
    tip2: '為了您的帳號數據安全，需驗證當前操作人員信息',
    tip3: '試生產的櫃子須為，{fontStyleStart}不對稱的櫃體，以避免出現櫃體鏡像{fontStyleEnd}的問題'
    },
  printTag: {
    dualLanguageTip: '您暫無中英雙語標籤生成權限，當前僅可預覽；如需正式使用，請聯繫銷售開通~',
    generateDualLanguageTagTip: '生成中英雙語標籤',
    dualLanguageTip2: '該功能為付費功能，請聯繫銷售開通後使用~',
    effectiveDataSource: '生效數據源',
    partName: '板件名'
    },
  userAccessToken: {
    createTime: '創建時間',
    lastUsedTime: '最近使用時間',
    expireTime: '過期時間',
    status: '狀態',
    tokenNamePlaceholder: '請輸入令牌名稱',
    expireTimeSelectPlaceholder: '請選擇過期時間',
    securityBannerTip: '請勿與他人共享您的個人存取權杖，也不要在瀏覽器或其他用戶端程式碼中暴露它，以保護您的帳戶安全；若在公開場合發現任何外洩的個人存取權杖，該權杖可能會被自動停用。',
    expired: '已過期',
    valid: '有效',
    remove: '移除',
    previewOnceWarning: '此權杖僅顯示一次，請將此金鑰保存在安全且可取得之處。請勿與他人共享，也不要在瀏覽器或其他用戶端程式碼中暴露它。',
    token: '權杖',
    deleteConfirm: '確定要刪除此權杖嗎？',
    userAccessToken: '用戶存取權杖',
    dayUnit: '天',
    custom: '自訂',
    previewModalTitle: '新的個人存取權杖',
    addModalTitle: '新增個人存取權杖'
    },
  bujianStore: {
    inputPlaceholder: '輸入板件條碼搜索補件小板',
    noData: '暫無數據',
    loadingErr: '補件板件加載失敗',
    noDrag: '無法放置，請點擊補件按鈕將板件放入補件庫',
    outOfCanvas: '無法放置，請核對板件材質、顏色和厚度屬性!'
    },
  alginTexture: {
    tip: '當前操作會清除板件對紋信息，請確認是否繼續？',
    tip2: '當前操作會影響板件間距，導致加工問題，請確認是否繼續？',
    group: '對紋組',
    groupTemp: '對紋組一',
    textureAlignmentPlank: '對紋板件無法移動'
    },
  customizeFolder: {
    customizeFolder: '文件夾自定義',
    customizeFolderTip: '注意：開啟文件夾自定義後，之前設定的分文件夾規則將不再生效',
    processingFilesTitle: '加工文件數據',
    dragToFolderTip: '可拖拽到左側文件夾中作為子文件夾或文件',
    folderNameEmpty: '文件夾名稱不能為空',
    folderNameExists: '存在同名文件夾',
    fileNotFound: '未能獲取到正確的文件',
    fileCannotBeClassified: '該類型文件不能放在任何分類文件夾下',
    cannotAddAtThisPosition: '不可添加在此位置',
    fileAlreadyExists: '【{name}】在此文件夾中已存在',
    confirmDeleteFolder: '是否確定刪除該文件夾？',
    confirmDeleteItem: '是否確定刪除【{name}】？',
    confirmDeleteFolderWithChildren: '此文件夾下存在其他文件夾/文件，是否確定刪除？',
    deleteFile: '刪除文件',
    addSubFolder: '添加子文件夾',
    editFolder: '編輯文件夾',
    deleteFolder: '刪除文件夾',
    rootCannotDelete: '根目錄無法被刪除',
    newFolder: '新建文件夾',
    fileUsedCanDrag: '已使用 - 可重複拖拽',
    fileDraggable: '可拖拽',
    addFileToFolder: '將 【{fileName}】 添加到 {folderName}',
    addFolderTitle: '添加文件夾',
    editFolderTitle: '編輯文件夾',
    folderNameLabel: '文件夾名稱',
    folderNamePlaceholder: '請輸入文件夾名稱',
    sequenceStartLabel: '遞增序號起始值',
    classifyMethodLabel: '分類方式',
    nameLengthLimitLabel: '字符長度限制',
    tagInsertTip: '點擊標籤可插入到文件夾名稱中',
    classifyTagInsertTip: '點擊標籤可插入到文件夾名稱中，文件將按照指定標籤進行分類',
    engraving_front: '雕刻機正面文件',
    engraving_opposite: '雕刻機反面文件',
    engraving_merge: '雕刻機合併文件',
    engraving_mill: '二次加工牛角槽銑槽',
    engraving_haitang: '二次加工斜邊海棠角和斜邊拉手文件',
    engraving_arc_slot: '二次加工銑底圓弧槽',
    engraving_line_slot: '二次加工自定義刀路',
    engraving_straight_arc_slot: '二次加工圓弧折弯部分直槽',
    engraving_frame_door: '二次加工骨骼門文件',
    engraving_inner_shape: '二次加工內部異形',
    engraving_hole: '二次加工常規孔',
    engraving_slot: '二次加工常規槽',
    engraving_single_file_merge: '二次加工合併文件',
    electronic_saw: '電子鋸文件',
    glass: '玻璃切割機文件',
    glass_machine: '玻璃切割機',
    side_machine: '側孔機文件',
    side_machine_xml3: '舊版側孔機XML3文件',
    side_machine_txt: '舊版側孔機TXT文件',
    side_machine_nc: '舊版側孔機nc文件',
    dock56F: '五/六面鑽文件',
    ptp: 'PTP文件',
    aio: '一體機文件',
    aio_anc: '一體機正面anc文件',
    labeling_1: '貼標機文件1',
    labeling_2: '貼標機文件2',
    labeling_3: '貼標機文件3',
    robotic_arm: '機械臂文件',
    label_image: '標籤圖片文件',
    label_pdf: '標籤PDF文件',
    paiban_image: '排版圖圖片文件',
    paiban_pdf: '排版圖PDF文件',
    engraving: '雕刻機',
    electronic: '電子鋸',
    side_hole: '側孔機',
    drilling: '五/六面鑽',
    labeling: '貼標機',
    robotic: '機械臂',
    label: '標籤',
    warningTip: '請注意: 花括號【{}】及其內容需保證完整性，請勿手動刪除/增加!',
    fileClassifyError: '此文件不能按照{classifyNames}分類',
    folderClassifyByTextureColorThickSize: '根據顏色、材質、厚度、大板尺寸歸為不同文件夾(貼標文件一起)',
    unnamed: '未命名',
    specialText: '特殊',
    surplusText: '餘料',
    normalText: '常規',
    plankText1: '板',
    resetTemplate: '模板重置',
    resetTemplateConfirm: '是否確認重置模板?',
    clearTemplate: '模板清空',
    clearTemplateConfirm: '是否確認清空模板?',
    legendFixedFolder: '固定文件夾',
    legendClassifyFolder: '分類文件夾',
    legendFixedTag: '固定數據',
    legendNormalTag: '動態數據',
    legendClassifyTag: '分類動態數據',
    door_wall_aio: '門牆櫃一體機',
    noPermission: '您目前無自訂資料夾權限，請聯繫銷售購買後使用',
    enableCustomFolder: '開啟文件夾自定義',
    exporttagTip: '順帶導出標籤PDF、圖片同時勾選時，預設選擇PDF進行傳送'
    },
  paibanTask: {
    pausedTip: '已暫停任務',
    deleteTip: '確定刪除任務「{taskBatch}」嗎？刪除後不可恢復。',
    continueTip: '繼續排版任務',
    completed: '已完成',
    failed: '任務失敗',
    paused: '暫停中',
    pending: '等待中',
    running: '排版中',
    extraTip: '排版任務僅展示最近一周的數據，請完成任務後手動將任務保存至歷史！',
    taskStatus: '任務狀態',
    createTaskTip: '創建排版任務，進入後台排版',
    taskBatchTitle: '任務批次',
    relatedOrderNosTitle: '關聯訂單號',
    progressTitle: '排版進度',
    boardCountTitle: '大板用量估算',
    optimizedAreaTitle: '優化面積估算',
    productionLineTitle: '生產線',
    operationTitle: '操作',
    optimizeRateTitle: '优化率估算',
    optimizeRateTip: '未計算自動裁剪餘料利用率',
    optimizeRateTip2: '具體優化率以排版頁為準',
    boardCountTip: '具體大板用量以排版頁為準',
    optimizedAreaTip: '具體優化面積以排版頁為準',
    paibanSettingTip: '查詢到當前任務生產線設置發生過修改，當前排版結果和實際導出生產文件可能存在衝突，建議重新排版生產',
    dataException: '數據異常，請刷新頁面重試'
    },
  paibanSetting: {
    advancedSetting: '高級設置',
    advancedFeature: '高級功能',
    surplusCutSpeedUp: '余料切割智能提速',
    surplusCutSpeedUpTip4: '功能開發中,敬請期待',
    surplusCutSpeedUpTip: '余料排版間距自動為0',
    surplusCutSpeedUpTip2: '余料切割自動跳過已切及修邊路徑，提升余料裁剪效率',
    surplusCutSpeedUpTip3: '該功能僅對雕刻機與一拖二雕刻機生效（請勿與共邊切割，共邊加速功能一起使用）',
    surplusCutSpeedUpTip5: '僅對雕刻機與一拖二雕刻機生效',
    featureDisplay: '功能顯示',
    featureDisplayTip: '本頁面僅控制功能入口是否顯示，不修改功能本身的啟用狀態與參數配置'
    },
  alignedPlan: {
    deepSearch: '深度計算',
    deepSearchTip: '專屬功能，可通過重新排版增加計算深度，以獲取更優排版結果',
    deepSearchTip2: '升級深度計算後，可通過重新排版增加計算深度，以獲取更優排版結果，當前可試用',
    deepSearchTip3: '深度計算給出更省板方案',
    deepSearchTip4: '當前暫無深度計算排版權限，請聯繫銷售購買後使用。',
    deepSearchTip5: '升級深度計算後，享有專屬伺服器算力支持，進一步提升排版質量，當前可預覽'
    }
  }